import { AuthService } from "@js/services/AuthService";
import { CaseService } from "@js/services/CaseService";
import { DevelopmentInputService } from "@js/services/DevelopmentInputService";
import { OrganisationService } from "@js/services/OrganisationService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import { LoginController } from "./LoginController";
import {
  AccountClient,
  ApplicationUser,
  ApplicationUserClient,
  ApplicationUserCrudClient,
  BrickflowEventLogClient,
  Case,
  CaseAccessLevelEnum,
  CaseClient,
  CaseLender,
  CaseLenderClient,
  CaseLenderStateEnum,
  CaseNote,
  CaseNoteClient,
  CaseStatusEnum,
  Client,
  DevelopmentInput,
  DevelopmentInputClient,
  DevelopmentInputWithNoLogin,
  DevelopmentInputWithNoLoginClient,
  EventLogEnum,
  HubspotContactRequest,
  IntroducerClient,
  InviteClient,
  LenderClient,
  LenderResult,
  LenderResultClient,
  LenderResultMinimalDTO,
  LenderResultSetDTO,
  LenderResultSummaryDTO,
  LicenseMasterStatusEnum,
  Organisation,
  OrganisationClient,
  PaymentClient,
  PreviousDevelopmentsEnum,
  ProductFamilyEnum,
  ProductTypeEnum,
  PropertyTypeEnum,
  SelectedResult,
  ShareDealDTO,
  SortByEnum,
  StaticDataClient,
  UserClient,
  UserRoleEnum,
  UserSimpleDTO,
} from "@src/apis/ModularClient";
import { MaxFlatUnitPriceEnum } from "@js/models/enum/MaxFlatUnitPriceEnum";
import { MaxHouseSalePriceEnum } from "@js/models/enum/MaxHouseSalePriceEnum";
import { MaxSqFtSalePriceEnum } from "@js/models/enum/MaxSqFtSalePriceEnum";
import { PersonalGuaranteeLevelEnum } from "@js/models/enum/PersonalGuaranteeLevelEnum";
import { ShareholderDepositRequiredEnum } from "@js/models/enum/ShareholderDepositRequiredEnum";
import { Expand, getOneUsingOData } from "@ccq/ts-lib";
import { IndexService } from "@js/services/IndexService";
import { ODataHelper } from "@js/helpers/ODataHelper";

interface ResultArrayMobile {
  name: string;
  array: LenderResultMinimalDTO[];
  template: string;
  headerTemplate: string;
  order: number;
}

export class LenderResultScreenController {
  loadingData: boolean = false;

  // tourState: any = {
  //   tourStep: 1,
  //   tourTotalSteps: 0,
  // };
  // tourEnabled: boolean = false;

  assistanceSlider: boolean = true;
  offer: LenderResultSummaryDTO;

  totalLender: number = 0;

  enquiryOpen: boolean;
  enquiryEmail: string;
  enquiryBody: string;
  enquiryTelephone: string;
  sentmessage: boolean = false;
  sendingmessage: boolean = false;
  firstTime: boolean = true;

  fetchingMatches: boolean;
  fetchingLargest: boolean;
  fetchingMezzanine: boolean;
  fetchingEquity: boolean;

  mezzanineLenders: boolean;
  equityLenders: boolean;
  guidanceCheckbox: boolean = true;
  showVideo: boolean = false;
  isSearch: boolean = true;
  isMaximumLoanRequired: boolean = true;
  tempLoanRequired: number;
  showHelpText: boolean = true;
  productIdAttachedToCase: number;

  loanCriteria: DevelopmentInput;

  results: LenderResultSetDTO;

  matchingResults: LenderResultMinimalDTO[];
  largestResults: LenderResultMinimalDTO[];
  mezzanineResults: LenderResult[];
  equityResults: LenderResult[];
  allResults: ResultArrayMobile[] = [];
  selectedResultArray: LenderResult[];

  summarySearchResults: LenderResultSummaryDTO[];

  selectedResult: LenderResult;
  selectedResultForAttachingToCase: LenderResultMinimalDTO;

  comparisonList: LenderResultMinimalDTO[] = [];
  summaryComparisonList: LenderResultSummaryDTO[] = [];
  totProjCosts: number;
  showsaveinfo: boolean = false;
  hideusername: boolean = true;
  caseid: number = null;
  searchid: number = null;
  uniqueId: string = null;

  hideCaseCreation: boolean = false;
  loanLabel: string;
  limitmatches: boolean = true;
  limitlargestmatches: boolean = true;
  showSaveResults: number;
  warningOff: boolean = false;
  doubleWarningOff: boolean = false;
  currentCase: Case;
  currentProductOnCase: string;
  caseUpdated: boolean = false;
  switchingProduct: boolean = false;
  productResultList: number;
  productId: number;
  caseLenders: CaseLender[];
  caseLendersNotInResults: CaseLender[];
  filterLenderNames: string[] = [];

  sliderShown: boolean;
  updatedResultsWithSlider: boolean = false;

  rowsShown: number = 4;
  emailJourneyStarted: boolean = true;
  searchNameCache: string;

  //Introducers
  clientFirstName: string;
  clientSurname: string;
  clientEmail: string;
  notifyBorrower: boolean = true;

  // confirmation before leave
  confirmSaving: boolean = false;
  prevPath: string;

  loanCriteriaWithoutCredentials: DevelopmentInput;
  showProductNote: boolean = false;
  productNote: string;

  savePressed: boolean = false;

  //Capture name and email address & send results to unregistered searcher
  newUserCaptureForm: FormData;
  newUser: ApplicationUser = {} as ApplicationUser;
  //captureFirstName: string;
  //captureSurname: string;
  //captureEmail: string;
  //applicantDefinedRole: ApplicantRoleEnum;
  agreedToBeEmailed: boolean = false;
  error: string = "";
  // Flag to disable or enable the Save as button depending on the click.
  isClicked: boolean = false;
  showContactBrokerModal: boolean = false;
  hasAccessToDeal: boolean = true;

  //Carousel
  carouselData: string[] = [
    "Brickflow is the quickest and easiest way to apply for development finance.",
    "To protect borrowers, we only work with the UK's most reputable and financially secure lenders.",
    "We work with mainstream & challenger banks, as well as specialist development lenders.",
    "The results below are estimates based on critera provided to us by our lenders.",
    "To get a Lender Approved Decision in Principle (DIP), select up to 3x loan options below and click Proceed.",
  ];
  carouselStep: number = 0;

  //For admins accessing client accounts
  clientUsernameBeingAccessed: string;

  toggleEditSearchName: boolean = false;

  isBlankSearch: boolean = false;

  isAdmin: boolean = false;
  debug1: boolean = false;

  showActionPanel: boolean = false;

  isLoggedInUser: boolean = false;
  isLegacyUser: boolean = false;

  isProceedClicked: boolean = false;
  isDIPClicked: boolean = false;

  tempSearchName: string = null;

  isLoggingOut: boolean = false;

  //These are added for new search functinality
  existingUsers: UserSimpleDTO[];
  isNewSearch: boolean;
  newSearch: boolean = false;
  existingborrower: boolean;
  clientPhoneNumber: string;
  showClientDetails: boolean = false;
  isBroker: boolean = false;
  clientId: number = null;
  isreferredSearch: boolean = false;
  isIntroducer: boolean = false;
  isIntroduceronly: boolean = false;
  isLender: boolean = false;
  searchName: string = null;
  searchReference: string;
  newSearchId: number;

  //Accordion
  accordionShow: boolean[] = [];
  showRequestEmailForm: boolean = false;
  requestMessageReason: string = "";
  message: boolean = false;
  messageContent: string;
  sendingMessage: boolean = false;

  appName: string;

  guid: string = null;
  isSaveorSaveAsClicked: boolean = false;
  showOnlyRegisterButton: boolean = false;
  noOfShortlistAllowed: number = 5;
  emailClient: boolean = false;
  displayMsg: string = null;
  showMsg: boolean = false;
  showMsgToAdminOrBroker: boolean = false;
  ShowdeleteSearch: boolean = false;
  newLeadFirstName: string;
  newLeadLastName: string;
  newLeadEmail: string;
  isResultScreen: boolean = true;
  isSaveClientSearch: boolean = false;
  selecteduserName: string;

  isClient: boolean = false;

  numberOfPreviousDevelopmentsOptions = [];
  depositRequiredFromShareholdersOptions = [];
  personalGuaranteeLevelOptions = [];
  maxHouseSalePriceOptions = [];
  maxFlatUnitPriceOptions = [];
  maxSqFtSalePriceOptions = [];
  maxPercCommercialForMixedUseOptions = [];
  locationOptions = [];
  maxCommercialFloorspaceOptions;

  shareholderDepositRequired = null;
  personalGuaranteeLevel = null;
  maxHouseSalesPrice = null;
  maxFlatUnitPrice = null;
  maxSqFtSalePrice = null;
  maxSqFtSalePriceFlats = null;
  maxPercCommercialForMixedUse = null;
  tempLoanCriteria = null;
  previousDevelopments = null;

  showFilters: boolean = false;
  isFilterUpdate: boolean = false;
  showSortBy: boolean = false;

  isShortlistingMore: boolean = false;

  showContactLender: boolean = false;
  shareForm: ng.IFormController;
  shareFirstName: string;
  shareNote: string;
  lenderEmail: string;
  shareEmailSubject: string;
  sharedSearch: boolean = false;
  dataLoading: boolean = false;
  isSaveAsWthOutIntroducee: boolean = false;
  hasSearchChanged: boolean = false;
  hasCriteriaChanged: boolean = false;
  orgCode: string;
  orgName: string;
  brokerDetail: string = "";
  reloadSearch: boolean = false;
  brokerageOrg: Organisation;
  brokerageOrgFilename: string;
  showMessageToborrower: boolean = false;
  borrowerMessage: string = "";
  user: ApplicationUser;
  moveContactBrokerBtnInMiddle: boolean = false;
  clientOrganisationPhoneNumber: string;
  showBridgingEligibility: boolean = false;
  isBridging: boolean = false;
  isOldDevFinance: boolean = true;
  showLenderNamesAndLogosOverride: boolean = false;
  userRole: string;
  userDetails: string;
  userLenderId: number = null;

  //New enterprise journey
  showEnterpriseRegistrationModal: boolean = false;
  projectName: string = "";
  registrationForm: ng.IFormController;
  emailExistsError: boolean = false;
  enterpriseClientId: number = null;

  snapshotNewSearch: boolean = false;
  showPostcodeErrorMessage: boolean = false;
  postcodeErrorMsg: string;

  hasResultsProcessed: boolean = false;

  //SaveAs functionality
  isSaveAsClicked: boolean = false;
  saveAsSearchName: string;

  filterProperties = [
    "f_IsFirstTimeDeveloper",
    "f_NumberOfPreviousDevelopments",
    "f_ShareholderDepositRequired",
    "f_IsPersonalName",
    "f_IsOffshoreCompany",
    "f_IsMainShareholderOverseas",
    "f_PersonalGuaranteeLevel",
    "f_HasAdverseCredit",
    "f_MaxCommercialFloorspace",
    "f_IsAirRights",
    "f_IsModular",
    "f_IsPermittedDevelopmentScheme",
    "f_IsGradeOneListed",
    "f_IsGradeTwoListed",
    "f_MaxHouseSalesPrice",
    "f_MaxFlatUnitPrice",
    "f_MaxNumberOfUnits",
    //"f_MaxPercCommercialForMixedUse",
    "f_MaxSqFtSalePrice",
    "f_MaxSqFtSalePriceFlats",
    "f_IsWorkStarted",
    "f_IsChargeOnAdditionalProperty",
    "f_IsFixedRate",
  ];

  selectedUser: Expand<ApplicationUser>;

  static $inject = [
    "$route",
    "$routeParams",
    "$scope",
    "$rootScope",
    "$location",
    "$cookies",
    "LenderResultClient",
    "UserClient",
    "CaseService",
    "CaseClient",
    "DevelopmentInputService",
    "DevelopmentInputClient",
    "DevelopmentInputWithNoLoginClient",
    "IntroducerClient",
    "AuthService",
    "RoleService",
    "LenderClient",
    "InviteClient",
    "OrganisationClient",
    "OrganisationService",
    "AccountClient",
    "CaseNoteClient",
    "PaymentClient",
    "SelectListService",
    "CaseLenderClient",
    "BrickflowEventLogClient",
    "ApplicationUserClient",
    "ApplicationUserCrudClient",
    "StaticDataClient",
    "IndexService",
    "ODataHelper",
  ];

  constructor(
    private $route: ng.route.IRouteService,
    private $routeParams: ng.route.IRouteParamsService,
    private $scope: ng.IScope,
    public $rootScope: ng.IRootScopeService,
    private $location: ng.ILocationService,
    private $cookies: ng.cookies.ICookiesService,
    private lenderResultClient: LenderResultClient,
    private userClient: UserClient,
    private $CaseService: CaseService,
    private caseClient: CaseClient,
    private $DevelopmentInputService: DevelopmentInputService,
    private developmentInputClient: DevelopmentInputClient,
    private developmentInputWithNoLoginClient: DevelopmentInputWithNoLoginClient,
    private introducerClient: IntroducerClient,
    private $auth: AuthService,
    private roleService: RoleService,
    private lenderClient: LenderClient,
    private inviteClient: InviteClient,
    private organisationClient: OrganisationClient,
    private organisationService: OrganisationService,
    private accountClient: AccountClient,
    private caseNoteClient: CaseNoteClient,
    private paymentClient: PaymentClient,
    private selectListService: SelectListService,
    private caseLenderClient: CaseLenderClient,
    private eventLogClient: BrickflowEventLogClient,
    private applicationUserClient: ApplicationUserClient,
    private applicationUserCrudClient: ApplicationUserCrudClient,
    private staticDataClient: StaticDataClient,
    private indexService: IndexService,
    private odataHelper: ODataHelper,
  ) {
    if (this.$location.path().startsWith("/shortlistmore")) {
      this.isShortlistingMore = true;
    }

    if (
      window.self == window.top &&
      sessionStorage.getItem("userRole") &&
      sessionStorage.getItem("userRole") == "borrower" &&
      !$cookies.get("access_token")
    ) {
      document.getElementById("header").style.display = "none";
    } else if ($cookies.get("access_token")) {
      document.getElementById("header").style.display = "flex";
    }

    //Get CaseId & SearchId from route params. If the case don't have id, display the change serach menu
    if (this.$routeParams.CaseId) {
      this.caseid = Number(this.$routeParams.CaseId);
      this.isSearch = false;
    } else {
      this.isSearch = true;
    }

    if (this.$routeParams.SearchId) {
      this.searchid = Number(this.$routeParams.SearchId);
    } else {
      if (window.self == window.top && $cookies.get("access_token"))
        // Expanding a 'new search' panel for first time search execution
        this.sliderShown = (this.$rootScope as any).previousRoute.startsWith("/compare") ? false : true;
    }
    if (this.$routeParams.uniqueId) {
      this.uniqueId = this.$routeParams.uniqueId;
    }

    if (window.self == window.top && $cookies.get("access_token")) {
      //This block is to navigate a broker to userdashboard when they do not have a license.
      if (sessionStorage.getItem("isValidLicense") == "false") {
        this.$auth.clearSelectedNavMenuAndFilterStorageData();
        this.$location.path("/userdashboard");
      }
      this.isLoggedInUser = true;
      this.assistanceSlider = false; //assistance-slider open the fist time you access to the case
      this.loadingData = true;
      this.organisationService
        .getOrganisation()
        .then((organisation) => {
          if (organisation) {
            if (!organisation.isBrickflow) {
              this.clientOrganisationPhoneNumber = organisation.phoneNumber;
            }
            this.orgCode = organisation.isWhiteLabelled ? organisation.organisationCode : "";
            this.showLenderNamesAndLogosOverride = organisation.showLenderNames ?? false;
            if (organisation.isWhiteLabelled) {
              this.orgName = organisation.name.replace(/ /g, "_");
            } else {
              this.orgName = "Brickflow";
            }
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    } else {
      //not logged in so show the agree terms box every time
      this.selectedUser.lenderResultsTermsAgreed = false;
      this.determineSearchSource();
      if (window.self == window.top) {
        this.userRole = sessionStorage.getItem("userRole");
        this.isClient = this.userRole == "borrower";
        this.user = JSON.parse(sessionStorage.getItem("userDetails"));
        this.orgCode = this.$cookies.get("org_code");
        this.enterpriseClientId = Number(sessionStorage.getItem("clientId"));
      } else {
        this.orgCode = location.pathname.replace("/", "");
        this.guidanceCheckbox = false;
        Promise.all([
          this.organisationService.getData("userDetails").then((userDetails) => {
            if (userDetails) {
              this.user = JSON.parse(userDetails);
            }
          }),
          this.organisationService.getData("userRole").then((userRole) => {
            if (userRole) {
              this.userRole = userRole;
              this.isClient = this.userRole == "borrower";
            }
          }),
          this.organisationService.getData("clientId").then((clientId) => {
            if (clientId) {
              this.enterpriseClientId = Number(clientId);
            }
          }),
          this.organisationService.getData("newSearch").then((newSearch) => {
            this.snapshotNewSearch = Boolean(newSearch) == true;
          }),
        ])
          .then(() => {
            this.orgCode = location.pathname.replace("/", "");
            this.organisationService.sendDataToParent("newSearch", "false");
          })
          .catch((error) => {
            console.error("Failed to get user data: ", error);
          });
      }
    }

    this.getSearchLenderCount();

    // if (window.self == window.top) {
    //   let cookieTourStep = this.$cookies.get("tourStep");
    //   if (cookieTourStep) {
    //     this.tourState.tourStep = cookieTourStep;
    //   }
    // }

    if (this.caseid && this.caseid > 0) {
      this.getCase();
    } else {
      this.$CaseService.updateTubeMap(null);
    }

    if (window.self == window.top && sessionStorage.getItem("userDetails")) {
      this.showOnlyRegisterButton = true;
    }

    //if user is logged in, get profile
    if (window.self == window.top && this.$cookies.get("access_token")) {
      this.getCurrentUser().then((result) => {
        this.selectedUser = result;

        this.isLegacyUser = this.selectedUser.isLegacyUser;

        this.indexService.currentUserLicenseData.then((res) => {
          this.selectedUser.subscriptionStatus = res.subscriptionStatus;
        });

        this.roleService.isClientUser().then((response) => {
          this.isClient = response;

          if (this.clientOrganisationPhoneNumber && !this.isClient) {
            this.clientOrganisationPhoneNumber = null;
          }
        });

        this.roleService.isAdminUser().then((response) => {
          this.isAdmin = response;
          if (this.isAdmin) {
            this.getUsersBelongToBrokerOrAdmin();
          }
        });

        this.roleService.isBroker().then((response) => {
          this.isBroker = response;
          if (this.isBroker) {
            this.getUsersBelongToBrokerOrAdmin();
          }
        });

        this.roleService.isIntroducer().then((response) => {
          this.isIntroducer = response;
        });

        this.roleService.isIntroducerOnly().then((response) => {
          this.isIntroduceronly = response;
        });

        this.roleService.isLenderUser().then((response) => {
          this.isLender = response;
          if (this.isLender) {
            this.userClient.getCurrentUserLender().then((response) => {
              this.userLenderId = response;
            });
          }
        });

        this.determineSearchSource();
      });
    }

    // if (window.self == window.top) this.updateGuidanceState();

    this.checkShowBridgingEligibility();

    $scope.$on("$locationChangeStart", (event: ng.IAngularEvent) => {
      /*this.paymentClient.getLicense().then((response) => {
                    var license: LicenseMasterDTO = response;

                    if (license.Status == LicenseMasterStatusEnum.PaidUp
                        || license.Status == LicenseMasterStatusEnum.PaymentProcessing
                        || license.Status == LicenseMasterStatusEnum.PreCancel) {
                        this.saveChanges(event);
                    }
                });*/

      this.indexService.currentUserLicenseData.then((res) => {
        if (
          res.subscriptionStatus == LicenseMasterStatusEnum.PaidUp ||
          res.subscriptionStatus == LicenseMasterStatusEnum.PaymentProcessing ||
          res.subscriptionStatus == LicenseMasterStatusEnum.PreCancel
        ) {
          this.saveChanges(event);
        }
      });
    });

    let logoutUnregister = $rootScope.$on("logout", (event: ng.IAngularEvent) => {
      this.isLoggingOut = true;
      /* this.paymentClient.getLicense().then((response) => {
                     var license: LicenseMasterDTO = response;
 
                     if (license.Status == LicenseMasterStatusEnum.PaidUp
                         || license.Status == LicenseMasterStatusEnum.PaymentProcessing
                         || license.Status == LicenseMasterStatusEnum.PreCancel) {
                         this.saveChanges(event);
                     }
                 });*/

      this.indexService.currentUserLicenseData.then((res) => {
        if (
          res.subscriptionStatus == LicenseMasterStatusEnum.PaidUp ||
          res.subscriptionStatus == LicenseMasterStatusEnum.PaymentProcessing ||
          res.subscriptionStatus == LicenseMasterStatusEnum.PreCancel
        ) {
          this.saveChanges(event);
        }
      });
    });

    if (window.self == window.top) {
      $scope.$on("$destroy", logoutUnregister);

      // $rootScope.$on("guidanceStateChanged", (event: ng.IAngularEvent) => {
      //   this.updateGuidanceState();
      // });

      // $rootScope.$on("nextTour", (event: ng.IAngularEvent) => {
      //   this.tourNext();
      // });
      // $rootScope.$on("backTour", (event: ng.IAngularEvent) => {
      //   this.tourBack();
      // });
      // $rootScope.$on("skipTour", (event: ng.IAngularEvent) => {
      //   this.tourSkip();
      // });
    }

    // Set the broker information on the new user object
    if (
      this.$routeParams.brokerOrgUniqueRef !== undefined &&
      this.$routeParams.brokerOrgUniqueRef != "null" &&
      this.$routeParams.brokerUserId !== undefined &&
      this.$routeParams.brokerUserId != "null"
    ) {
      this.organisationClient
        .findOrganisationIdByUniqueRef(this.$routeParams.brokerOrgUniqueRef)
        .then((brokerOrgId: number) => {
          this.newUser.organisationReferralId = brokerOrgId;
          this.newUser.defaultBrokerOrganisationId = brokerOrgId;
        });
    }

    this.getAppName();

    this.numberOfPreviousDevelopmentsOptions = this.selectListService.GetNumberOfPreviousDevelopments();
    this.depositRequiredFromShareholdersOptions = this.selectListService.GetShareholderDepositRequired();
    this.personalGuaranteeLevelOptions = this.selectListService.GetPersonalGuaranteeLevels();
    this.maxHouseSalePriceOptions = this.selectListService.GetMaxHouseSalePrices();
    this.maxFlatUnitPriceOptions = this.selectListService.GetMaxFlatUnitPrices();
    this.maxSqFtSalePriceOptions = this.selectListService.GetMaxSqFtSalePrices();
    this.locationOptions = this.selectListService.GetLocations();
    this.maxCommercialFloorspaceOptions = this.selectListService.GetMaxCommercialFloorspaceOptions();
  }

  private async getCurrentUser() {
    return await getOneUsingOData(this.applicationUserCrudClient, {
      filter: { id: { eq: await this.indexService.currentUserId } },
    });
  }

  getRequiredRoles(isCaseDashboard: boolean) {
    if (isCaseDashboard) return `['Admin', 'Client', 'Broker', 'Introducer']`;
    return `['Admin', 'Client', 'Broker', 'Introducer', 'Lender']`;
  }

  saveChanges(event: ng.IAngularEvent) {
    if (!(this.isBroker && (this.$routeParams.uniqueId || this.searchid))) {
      if (this.warningOff) {
        this.warningOff = false;
        return;
      } else {
        if (!this.showSaveResults && !this.searchid && !this.doubleWarningOff && this.isLoggedInUser) {
          this.prevPath = this.$location.url();
          event.preventDefault();
          this.confirmSaving = true;
          //var leaveWithoutSave = confirm("Are you sure you want to leave this page without saving your results?")
        }
      }
    }
  }

  cancelSavingResults() {
    event.preventDefault();
    this.confirmSaving = false;
    if (this.loanCriteria.searchName && !this.loanCriteria.searchName.startsWith("My Development Finance Search")) {
      this.isSaveorSaveAsClicked = true;
      this.register(false, this.productResultList);
    } else {
      this.showSaveResults = 1;
    }
  }

  cancelSaving() {
    this.warningOff = true;
    this.confirmSaving = false;

    if (this.isLoggingOut == true) {
      this.isLoggingOut = false;
      this.$auth.logout();
    } else {
      this.$location.path(this.prevPath);
    }
  }

  determineSearchSource() {
    //if called from third party api
    if (this.$location.path().startsWith("/resultsExternalAPI")) {
      if (this.$routeParams.uniqeId !== undefined && this.$routeParams.uniqeId != "null") {
        //read back data using
        this.lenderResultClient
          .getByUniqueRef(this.$routeParams.uniqeId, 20)
          .then((results) => {
            (this.$rootScope as any).loanCriteria = results.developmentInput;
            this.loanCriteria = (this.$rootScope as any).loanCriteria;
            if (this.loanCriteria) {
              this.newUser.firstName = this.loanCriteria.introduceeFirstName;
              this.newUser.lastName = this.loanCriteria.introduceeSurname;
              this.newUser.email = this.loanCriteria.introduceeEmail;
              this.newUser.phoneNumber = this.loanCriteria.introduceePhone;
              this.tempLoanRequired = this.loanCriteria.cI_Dev_LoanReq;
              if (this.loanCriteria.cI_Dev_LoanReq > 0) {
                this.isMaximumLoanRequired = false;
              }
              this.isDIPClicked = this.loanCriteria.isFullCase;
            }
            //check if associated user if so makes sense to login to give full functionality
            if (this.loanCriteria.userId) {
              if (this.$cookies.get("access_token") === null || this.$cookies.get("access_token") === undefined) {
                if (this.loanCriteria.userId == null || this.loanCriteria.userId == 0) {
                  this.warningOff = true;
                  this.doubleWarningOff = true;
                  (this.$rootScope as any).loanCriteria = null;
                  this.$location.path("/loginandreturnto/");
                } else {
                  this.$location.path("/loginandreturnto/");
                }
              }
            }
            if (results.lenderResultSet) {
              this.matchingResults = results.lenderResultSet.matchingResults;
              this.allResults.push({
                order: 1,
                name: "Matching Results",
                template: "/views/partials/lender-results-mobile-table-row.html",
                headerTemplate: "/views/partials/lender-results-mobile-table-header.html",
                array: this.matchingResults,
              });

              this.largestResults = results.lenderResultSet.largestLoanResults;
              this.allResults.push({
                order: 2,
                name: "Alternative Options",
                template: "/views/partials/lender-results-mobile-largest-table-row.html",
                headerTemplate: "/views/partials/lender-results-mobile-largest-table-header.html",
                array: this.largestResults,
              });

              this.summarySearchResults = results.lenderResultSet.combinedSummaryResultSet;

              this.sortSummaryResults();
            }
          })
          .finally(() => {
            this.fetchingLargest = false;
            this.fetchingMatches = false;
            this.hasResultsProcessed = true;
          });
      }
    }
    //if called from introduced client link
    else if (this.$location.path().startsWith("/referredSearch")) {
      if (this.$routeParams.uniqueId !== undefined && this.$routeParams.uniqueId != "null") {
        this.isreferredSearch = true;
        if (this.$routeParams.showOnlyRegister == "true") {
          this.showOnlyRegisterButton = true;
          sessionStorage.setItem("userRole", UserRoleEnum.Broker.toString());
        }
        //Pull DevelopmentInputWithNoLogin search results
        this.developmentInputWithNoLoginClient
          .fetchByUniqueId(this.$routeParams.uniqueId)
          .then((results) => {
            if (!results) {
              if (this.isLoggedInUser) {
                this.displayMsg = `Changes have been made to this search by your client, you will now be taken back to your user dashboard`;
              } else {
                this.displayMsg = `Please contact your broker in order to access this case.`;
              }

              this.showMsgToAdminOrBroker = true;
            } else {
              this.loanCriteria = {} as DevelopmentInput;
              (<any>Object).assign(this.loanCriteria, results);

              //Prefill client details for popup
              this.confirmSaving = false;
              this.newUser.firstName = results.introduceeFirstName;
              this.newUser.lastName = results.introduceeSurname;
              this.newUser.email = results.introduceeEmail;
              this.newUser.phoneNumber = results.introduceePhone;

              if (this.loanCriteria) {
                this.isDIPClicked = this.loanCriteria.isFullCase;
                this.tempLoanRequired = this.loanCriteria.cI_Dev_LoanReq;
                if (this.loanCriteria.cI_Dev_LoanReq > 0) {
                  this.isMaximumLoanRequired = false;
                }
                if (this.isClient) {
                  this.loanCriteria.userId = this.loanCriteria.userId ? this.loanCriteria.userId : this.selectedUser.id;
                  this.loanCriteria.saveQueryAndResults = true;
                }
              }

              if (this.$routeParams.showOnlyRegister == "false") {
                this.isClient = true;
                this.loanCriteria.saveQueryAndResults = false;
              }

              if (this.isBroker || this.isAdmin) {
                this.loanCriteria.saveQueryAndResults = true;
              }

              this.updateResults();
            }
          })
          .finally(() => {
            this.loadingData = false;
            this.hasResultsProcessed = true;
          });
      }

      if (
        this.$routeParams.brokerOrgUniqueRef !== undefined &&
        this.$routeParams.brokerOrgUniqueRef != "null" &&
        this.$routeParams.brokerUserId !== undefined &&
        this.$routeParams.brokerUserId != "null"
      ) {
        if (this.selectedUser) {
          if (
            this.selectedUser.organisationReferralId == null &&
            this.selectedUser.defaultBrokerOrganisationId == null
          ) {
            this.organisationClient
              .findOrganisationIdByUniqueRef(this.$routeParams.brokerOrgUniqueRef)
              .then((orgId: number) => {
                this.selectedUser.organisationReferralId = orgId;
                this.selectedUser.defaultBrokerOrganisationId = orgId;
                this.userClient.processUserRegistrationAndUpdate(this.selectedUser.id, false);
              });
          }
        }
      }
    } else if (this.$location.path().startsWith("/securitycheck")) {
      this.$location.path("/casedashboard/" + this.$routeParams.caseId);
    }
    //if called with a saved entry
    else if (this.searchid) {
      this.loadingData = true;
      this.developmentInputClient
        .fetchCustom(this.searchid)
        .then((loanCriteria) => {
          if (loanCriteria.isFullCase && this.isLoggedInUser && this.isClient) {
            this.developmentInputClient.isUserHasAccessToCase(this.searchid).then((response) => {
              if (!response) {
                this.hasAccessToDeal = false;
                this.displayMsg = "Please contact your broker in order to access this case.";
                this.showMsgToAdminOrBroker = true;
              } else {
                this.postLoanCriteriaRetrieveProcessing(loanCriteria);
              }
            });
          } else {
            this.postLoanCriteriaRetrieveProcessing(loanCriteria);
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    } else {
      // We are no more storing loanCriteria as rootscope property when navigating to compare page.
      if (
        window.self == window.top &&
        sessionStorage.getItem("LoanCriteria") &&
        (this.$rootScope as any).previousRoute.startsWith("/compare")
      ) {
        this.loanCriteria = JSON.parse(sessionStorage.getItem("LoanCriteria"));
      } else {
        // Pull our loan criteria from rootScope.
        this.loanCriteria = (this.$rootScope as any).loanCriteria;
      }

      // This block handles the reloading results for borrower(with out login) on refresh of page
      if (
        !this.loanCriteria &&
        window.self == window.top &&
        sessionStorage.getItem("loanCriteria") &&
        !this.isLoggedInUser
      ) {
        this.loanCriteria = JSON.parse(sessionStorage.getItem("loanCriteria"));
      } else if (window.self == window.top && sessionStorage.getItem("loanCriteria")) {
        sessionStorage.removeItem("loanCriteria");
      }

      if (this.loanCriteria) {
        this.tempLoanRequired = this.loanCriteria.cI_Dev_LoanReq;
        if (this.loanCriteria.cI_Dev_LoanReq > 0) {
          this.isMaximumLoanRequired = false;
        }
        this.isDIPClicked = this.loanCriteria.isFullCase;
      }

      if (!this.loanCriteria) {
        this.$location.path("/");
      } else {
        if (this.selectedUser) {
          this.loanCriteria.userId = this.selectedUser.id;
        }

        if (
          !this.loanCriteria.id &&
          window.self == window.top &&
          this.loanCriteria.searchName &&
          !sessionStorage.getItem("searchuser") &&
          (this.isAdmin || this.isBroker)
        ) {
          this.loadingData = true;
          this.developmentInputClient
            .saveSearch(this.loanCriteria)
            .then((loanCriteria) => {
              this.warningOff = true;
              this.go("/results/" + loanCriteria);
            })
            .finally(() => {
              this.loadingData = false;
            });
        } else if (window.self == window.top && sessionStorage.getItem("searchuser")) {
          let data = sessionStorage.getItem("searchuser");
          let userdetails = JSON.parse(data);
          this.clientFirstName = userdetails.clientFirstName;
          this.clientSurname = userdetails.clientSurname;
          this.clientEmail = userdetails.clientEmail;
          this.clientPhoneNumber = userdetails.clientPhoneNumber;
          this.clientId = userdetails.clientId;
          this.existingborrower = userdetails.existingborrower;
          this.loanCriteria.searchName = userdetails.searchName;
          if (this.existingborrower) {
            this.showClientDetails = true;
            this.loanCriteria.user = userdetails.clientUser;
            this.loanCriteria.userId = this.clientId;
          } else {
            this.loanCriteria.userId = this.selectedUser.id;
          }

          sessionStorage.removeItem("searchuser");

          this.sendResultsToClient(false, true);
        }

        if (!this.loanCriteria.searchName || this.loanCriteria.searchName.length == 0) {
          this.loanCriteria.searchName = this.defaultSearchName();
        }
        this.tempLoanCriteria = { ...this.loanCriteria };
        this.updateResults();
      }
    }
  }

  assistanceSliderCall() {
    return this.assistanceSlider;
  }

  recalcCosts(updatedField: string): void {
    switch (updatedField) {
      case "CI_Dev_BuildCosts":
        this.recalcCostPerArea();
        break;
      case "CI_Dev_Contingency":
        this.recalcCostPerArea();
        break;
      case "DC_AreaAcquisition":
        this.recalcCostPerArea();
        break;
    }
  }

  recalcCostPerArea(): void {
    let res: number = 0;
    //Case 4 - recalc cost per sq. m
    if (
      this.loanCriteria.cI_Dev_BuildCosts &&
      this.loanCriteria.cI_Dev_Contingency &&
      this.loanCriteria.dC_AreaAcquisition
    ) {
      res =
        (this.loanCriteria.cI_Dev_BuildCosts * (1 + Number(this.loanCriteria.cI_Dev_Contingency))) /
        this.loanCriteria.dC_AreaAcquisition;
      this.loanCriteria.dC_BuildCostPerArea = res;

      if (
        this.loanCriteria.cI_EndPropType === PropertyTypeEnum.MixedUse ||
        this.loanCriteria.cI_EndPropType === PropertyTypeEnum.Residential
      ) {
        this.loanCriteria.dI_AreaSalesAreaResidential = this.loanCriteria.dC_AreaAcquisition;
      }
      if (this.loanCriteria.cI_EndPropType != PropertyTypeEnum.Residential) {
        this.loanCriteria.dI_AreaSalesAreaCommercial = this.loanCriteria.dC_AreaAcquisition;
      }
    }
  }

  newloan() {
    (this.$rootScope as any).loanCriteria = null;
    this.$location.path("/criteria/0/0/1");
  }

  getTubeMapValue() {
    return this.$CaseService.getTubeMap();
  }

  updateResults(saveResults?: boolean, updateLoanLabels: boolean = false) {
    Promise.all([
      this.organisationService.getData("userDetails").then((userDetails) => {
        if (userDetails) {
          this.userDetails = userDetails;
          this.user = JSON.parse(userDetails);
        }
      }),
      this.organisationService.getData("userRole").then((userRole) => {
        if (userRole) {
          this.userRole = userRole;
          this.isClient = userRole == "borrower";
        }
      }),

      //Check if is a new search when inside iframe
      this.organisationService.getData("newSearch").then((newSearch) => {
        if (newSearch) {
          this.snapshotNewSearch = newSearch == "true";
        }
      }),
    ])
      .then(() => {
        this.organisationService.sendDataToParent("newSearch", "false");
        const originalSaveState = this.loanCriteria.saveQueryAndResults;
        // If saveResults is set, override it temporarily.
        if (saveResults !== undefined) {
          this.loanCriteria.saveQueryAndResults = false;
        }
        this.tempLoanCriteria = { ...this.loanCriteria };
        this.fetchingLargest = true;
        this.fetchingMatches = true;

        //Determine whether we have a blank search & show message
        if (
          (this.loanCriteria.cI_Dev_OrigPP == 0 &&
            this.loanCriteria.cI_EndPropType == 0 &&
            this.loanCriteria.cI_GDV == 0 &&
            this.loanCriteria.cI_Dev_LoanReq == 0) ||
          this.loanCriteria.cI_GDV == 0 ||
          this.loanCriteria.cI_Dev_BuildTerm == 0 ||
          this.loanCriteria.cI_Dev_BuildCosts == 0 ||
          this.loanCriteria.cI_Dev_LoanTermReq == 0
        ) {
          this.isBlankSearch = true;
          this.loadingData = false;
        } else {
          this.isBlankSearch = false;
          let selectedResults: SelectedResult[] = this.loanCriteria.selectedResults || [];
          let rootScopeLoanCriteriaId = (this.$rootScope as any)?.loanCriteria?.Id;

          if (
            window.self == window.top &&
            sessionStorage.getItem("LoanCriteria") &&
            (this.$rootScope as any).previousRoute.startsWith("/compare")
          ) {
            selectedResults = JSON.parse(sessionStorage.getItem("LoanCriteria")).selectedResults;
            //Removing the lsd data saved for compare view.
            sessionStorage.removeItem("LoanCriteria");
          }

          if (
            !this.selectedUser.newUserEmailJourneyStarted &&
            !this.searchid &&
            this.selectedUser.applicantDefinedRole == 0 &&
            !this.$routeParams.uniqueId
          ) {
            this.emailJourneyStarted = false;
          } else if (this.$routeParams.uniqueId) {
            this.emailJourneyStarted = true;
          } else {
            this.emailJourneyStarted = true;
          }

          var orgCode;

          if (window.self == window.top) {
            orgCode = this.$cookies.get("org_code");
          } else {
            orgCode = location.pathname.replace("/", "");
          }

          if (orgCode) {
            this.loanCriteria.referralOrgCode = orgCode;
          }

          if (window.self == window.top) {
            if (sessionStorage.getItem("userDetails") && sessionStorage.getItem("userRole")) {
              let role = sessionStorage.getItem("userRole") == "broker";
              let data = sessionStorage.getItem("userDetails");
              this.populateNewLeadInfo(role, data);
            }

            //Check if new search (not in iframe)
            this.snapshotNewSearch = sessionStorage.getItem("newSearch") == "true";
            sessionStorage.setItem("newSearch", "false");
          } else {
            if (this.userRole && this.userDetails) {
              let role = this.userRole == "broker";
              this.populateNewLeadInfo(role, this.userDetails);
            }
          }

          var criteriaChanged = this.hasCriteriaChanged || this.snapshotNewSearch;
          sessionStorage.setItem("newSearch", "false");
          this.hasCriteriaChanged = false;
          this.snapshotNewSearch = false;

          this.lenderResultClient
            .productsOfferingLargestLoanAndMatching(
              true,
              true,
              0,
              false,
              "",
              "",
              "",
              this.GetSelectedLabel(),
              this.emailJourneyStarted,
              this.loanCriteria,
              this.debug1,
              this.roleService.getIsLenderVisible(),
              this.newLeadFirstName,
              this.newLeadEmail,
              "",
              this.userRole,
              this.orgCode,
              this.isreferredSearch,
              criteriaChanged,
            )
            .then((results) => {
              this.results = results;
              if (!this.isLoggedInUser && !this.$routeParams.showOnlyRegister) {
                if (!this.user && !this.enterpriseClientId) {
                  this.showEnterpriseRegistrationModal = true;
                  document.getElementById("body").style.overflow = "hidden";
                }
              }

              if (this.results.developmentInputWithNoLoginUniqueRef) {
                this.loanCriteria.uniqueRef = this.results.developmentInputWithNoLoginUniqueRef;

                if (!this.isLoggedInUser) {
                  this.getOrganisationAndBrokerDetails();
                  sessionStorage.setItem("loanCriteria", JSON.stringify(this.loanCriteria));
                  if (!this.user && this.enterpriseClientId) {
                    this.addClientAndRenameDeal();
                  }
                }
                this.eventLogClient.logPageLoad(
                  "LENDERRESULTS",
                  this.orgCode,
                  this.loanCriteria?.introduceeEmail,
                  "borrower",
                  this.loanCriteria.organisationLinkId != null ? this.loanCriteria.organisationLinkId : 0,
                  ProductTypeEnum.Development,
                  this.loanCriteria?.uniqueRef,
                );
              }

              if (!this.isLoggedInUser && this.$routeParams.showOnlyRegister) {
                this.getOrganisationAndBrokerDetails();
                this.eventLogClient.logPageLoad(
                  "LENDERRESULTS-USING-EMAIL-LINK",
                  this.orgCode,
                  this.loanCriteria?.introduceeEmail,
                  "borrower",
                  this.loanCriteria.organisationLinkId != null ? this.loanCriteria.organisationLinkId : 0,
                  ProductTypeEnum.Development,
                  this.$routeParams.uniqueId,
                );
              }

              if (
                this.isLoggedInUser &&
                results.id > 0 &&
                this.isClient &&
                this.$location.path().startsWith("/referredSearch") &&
                this.$routeParams.uniqueId !== undefined &&
                this.$routeParams.uniqueId != "null"
              ) {
                this.eventLogClient.logPageLoad(
                  "AFTER-BORROWER-REGISTRATION",
                  this.orgCode,
                  this.selectedUser.userName,
                  "borrower",
                  this.loanCriteria.organisationLinkId,
                  ProductTypeEnum.Development,
                  this.$routeParams.uniqueId,
                );
                this.go("/results/" + results.id);
              }

              this.matchingResults = results.matchingResults;
              this.largestResults = results.largestLoanResults;
              this.allResults.push({
                order: 1,
                name: "Matching Results",
                array: this.matchingResults,
                template: "/views/partials/lender-results-mobile-table-row.html",
                headerTemplate: "/views/partials/lender-results-mobile-table-header.html",
              });
              this.allResults.push({
                order: 2,
                name: "Alternative Options",
                array: this.largestResults,
                template: "/views/partials/lender-results-mobile-largest-table-row.html",
                headerTemplate: "/views/partials/lender-results-mobile-largest-table-header.html",
              });

              this.summarySearchResults = results.combinedSummaryResultSet;

              this.sortSummaryResults();

              if (rootScopeLoanCriteriaId && selectedResults && selectedResults.length > 0) {
                this.loanCriteria.selectedResults = selectedResults;
              }

              if (
                this.searchid &&
                !this.selectedUser.newUserEmailJourneyStarted &&
                this.selectedUser.applicantDefinedRole == 0
              ) {
                this.lenderResultClient
                  .startNewUserEmailJourney(
                    this.loanCriteria.uniqueRef,
                    results.matchingResults.length,
                    results.largestLoanResults.length,
                  )
                  .then(() => {
                    this.selectedUser.newUserEmailJourneyStarted = true;
                  });
              }
              this.restoreSelectedItems(selectedResults);
            })
            .catch((error) => {
              //this.matchingResults = [];
              //this.largestResults = [];
            })
            .finally(() => {
              this.fetchingLargest = false;
              this.fetchingMatches = false;
              this.loanCriteria.saveQueryAndResults = originalSaveState;

              if (updateLoanLabels) {
                this.updateLoanLabels();
              }

              this.loadingData = false;
              this.isFilterUpdate = false;
            });
        }
      })
      .catch((error) => {
        // One or both of the promises were rejected, handle the error
        console.error("Failed to get user data: ", error);
      });
  }

  /**Update the loan label in the comparison results based on the loan label returned in the results
   * Primary purpose is to update the loan label when the show lender names button is toggled
   * */
  updateLoanLabels() {
    for (var i = 0; i < this.comparisonList.length; i++) {
      let resultIndex = this.summarySearchResults.findIndex(
        (item) => item.productID == this.comparisonList[i].seniorProductID,
      );

      if (resultIndex > -1) {
        this.comparisonList[i].loanLabel = this.summarySearchResults[resultIndex].loanLabel;
      }
    }

    //This is user for shortlisting pdf
    this.prepareDataForShortlistPdf();
  }

  populateNewLeadInfo(role, data) {
    let userdetails = JSON.parse(data);
    let userFullName = userdetails.FullName;
    let spaceIndex = userFullName.indexOf(" ");

    let firstName = "";
    let lastName = "";

    // if not space has been added to the name then put the whole name in the first name field
    if (spaceIndex == -1) {
      firstName = userFullName;
    } else {
      firstName = userFullName.substring(0, userFullName.indexOf(" "));
      lastName = userFullName.substring(userFullName.indexOf(" ") + 1);
    }

    this.newLeadFirstName = firstName;
    this.newLeadLastName = lastName;
    this.newLeadEmail = userdetails.Email;
  }

  restoreSelectedItems(selectedResults: SelectedResult[]) {
    if (selectedResults) {
      selectedResults.forEach((item, index) => {
        let match;
        var found = false;
        // first compare whether the selectedResultDTO is already an active caseLender record, if so it MUST be kept
        if (this.caseLenders) {
          found = this.caseLenders.some((cl) => cl.productId == item.productId);
        }

        if (!found) {
          found = this.summarySearchResults.some(
            (result) =>
              result.productID === item.productId &&
              result.caseLenderStatus != CaseLenderStateEnum.Rejected &&
              result.caseLenderStatus != CaseLenderStateEnum.Withdrawn,
          );
        }
        // Keeping this here rather than using summarySearchResults (above) because otherwise comparison etc stops working as it relies on using LenderResultMinimalDTO
        if (found) {
          if (item.menuId === 1) {
            match = this.matchingResults.find(
              (result) => result.seniorProductID === item.productId && result.calculatedBasedOnMatchingLoan === true,
            );
          } else if (item.menuId === 2) {
            match = this.largestResults.find(
              (result) => result.seniorProductID === item.productId && result.calculatedBasedOnMatchingLoan === false,
            );
          }
        }

        if (match) {
          /* 'this.isFilterUpdate' condition is to fix the issue with wrong number display beside toggle button when using filter*/
          if (this.isFilterUpdate) {
            var comparematch = this.comparisonList.filter((result) => result.seniorProductID == item.productId);
            var index = this.comparisonList.indexOf(comparematch[0]);
            if (index !== -1) {
              this.comparisonList[index] = match;
            } else {
              this.comparisonList.push(match);
            }
          } else {
            this.comparisonList.push(match);
          }

          if (index === 0) {
            this.selectedResultForAttachingToCase = match;
          }
        }
      });
    }
  }

  //Show whose account is being accessed if admin is accessing client
  getEmailOfClientBeingAccessed(): string {
    if (this.selectedUser && this.loanCriteria && this.selectedUser.id !== this.loanCriteria.userId) {
      return this.loanCriteria.ownerUser;
    }
  }

  indexPopup(methodName: string) {
    this.$rootScope.$broadcast(methodName);
  }

  lenderResultsIntroSeen(): boolean {
    if ((this.$rootScope as any).lenderResultsIntroSeen) {
      return true;
    } else {
      return false;
    }
  }

  captureNewUserEmail(): void {
    this.loadingData = true;
  }

  getCase() {
    this.loadingData = true;
    this.caseClient
      .fetch(this.$routeParams.CaseId)
      .then((result) => {
        this.currentCase = result;
        this.productId = result.productId;
        this.productResultList = result.productResultList;
        this.caseLenderClient.fetchByCaseId(this.currentCase.id).then((result) => {
          if (result) {
            this.caseLenders = result.filter(
              (cl) =>
                cl.caseLenderState != CaseLenderStateEnum.Withdrawn &&
                cl.caseLenderState != CaseLenderStateEnum.Rejected,
            );
          }
        });
        if (result.caseStatus == 0 || result.caseStatus == 1) {
          this.$CaseService.updateTubeMap(CaseStatusEnum.InProgress);
        } else {
          this.$CaseService.updateTubeMap(result.caseStatus);
        }
      })
      .finally(() => {
        this.loadingData = false;
      });
  }

  setSelectedItem(offer: LenderResultMinimalDTO) {
    this.matchingResults.forEach((item) => {
      item.selectedItem = false;
    });
    this.largestResults.forEach((item) => {
      item.selectedItem = false;
    });
    offer.selectedItem = true;
    this.selectedResultForAttachingToCase = offer;
  }

  toggleMezzanine() {
    this.mezzanineLenders = !this.mezzanineLenders;
    this.fetchingMezzanine = true;
    // Do some stuff
  }

  toggleEquity() {
    this.equityLenders = !this.equityLenders;
    this.fetchingEquity = true;
    // Do some stuff
  }

  comparisonContains(item: LenderResultSummaryDTO): boolean {
    var match = this.getLenderResultMinimalDTO(item);

    let found = !!this.comparisonList.find((result, index) => {
      return result === match;
    });

    if (found) {
    }

    return found;
  }

  checkLender(item: LenderResultSummaryDTO): boolean {
    if (this.userLenderId == item.lenderID) return true;
    return false;
  }

  selectionOrderNumber(item: LenderResultSummaryDTO) {
    //let found = !!this.comparisonList.find((result, index) => {
    //    return result === item;
    //});
    var match = this.getLenderResultMinimalDTO(item);
    var order = this.comparisonList.indexOf(match) + 1;

    if (order === 0) {
      return " ";
    }

    /* Adds number of active applications  */
    return order + (this.caseLendersNotInResults ? this.caseLendersNotInResults.length : 0);
  }

  toggleLenderComparisonSelection(item: LenderResultSummaryDTO) {
    /** This will check if the result shared with new user is active */
    var isActive = this.isResultActive();

    if (isActive) {
      // Find Lender offer within the original arrays to use on the compare view
      var match = this.getLenderResultMinimalDTO(item);

      var menuId = match.calculatedBasedOnMatchingLoan === true ? 1 : 2;

      if (this.loanCriteria) {
        if (!this.loanCriteria.selectedResults) {
          this.loanCriteria.selectedResults = [];
        }
        let selectedResultMatches: SelectedResult[] = this.loanCriteria.selectedResults.filter((result, index) => {
          return result.productId === match.seniorProductID && result.menuId === menuId;
        });

        let comparisonMatches: LenderResultMinimalDTO[] = this.comparisonList.filter((result, index) => {
          return result === match;
        });

        // Handle selected results for comparison or selection.
        if (!selectedResultMatches || selectedResultMatches.length === 0) {
          this.loanCriteria.selectedResults.push({
            productId: match.seniorProductID,
            developmentInputId: this.loanCriteria.id,
            menuId: menuId,
          } as SelectedResult);
          // If this is the first item, let's mark it as the selectedItem
          if (this.loanCriteria.selectedResults.length === 1) {
            this.productResultList = menuId;
            this.setSelectedItem(match);
          }
        } else {
          selectedResultMatches.forEach((value, index) => {
            this.loanCriteria.selectedResults.splice(this.loanCriteria.selectedResults.indexOf(value), 1);
          });
        }

        if (!comparisonMatches || comparisonMatches.length === 0) {
          this.comparisonList.push(match);
          this.eventLogClient.logEvent(
            `SHORTLISTING-RESULT`,
            EventLogEnum.Shortlisting,
            ProductTypeEnum.Development,
            this.$routeParams.uniqueId ? 0 : this.loanCriteria.id,
            this.$routeParams.uniqueId ? this.$routeParams.uniqueId : "",
            item.productID.toString(),
          );
        } else {
          comparisonMatches.forEach((value, index) => {
            this.comparisonList.splice(this.comparisonList.indexOf(value), 1);
          });
          this.eventLogClient.logEvent(
            `DESELECTING-SHORTHLISTED-RESULT`,
            EventLogEnum.Shortlisting,
            ProductTypeEnum.Development,
            this.$routeParams.uniqueId ? 0 : this.loanCriteria.id,
            this.$routeParams.uniqueId ? this.$routeParams.uniqueId : "",
            item.productID.toString(),
          );
        }
      }
    }

    this.loanCriteria.comparisonList = this.comparisonList;
  }

  viewOffer(offer: LenderResult) {
    this.selectedResult = offer;
  }

  goCompare() {
    /** This will check if the result shared with new user is active */
    var isActive = this.isResultActive();
    if (isActive) {
      this.warningOff = true;
      //We are setting this value to avoid displaying save modal while navigating to compare screen without saving search
      this.doubleWarningOff = true;
      // Makeing sure all the old data is deleted
      sessionStorage.removeItem("LoanCriteria");
      sessionStorage.removeItem("UniqueId");
      sessionStorage.removeItem("ComparisonList");
      sessionStorage.removeItem("TempSavedResults");

      sessionStorage.setItem("ComparisonList", JSON.stringify(this.getSummaryComparisonList()));
      sessionStorage.setItem("LoanCriteria", JSON.stringify(this.loanCriteria));

      if (this.uniqueId) {
        sessionStorage.setItem("UniqueId", this.uniqueId);
      }

      // temporarily put all results into saved results so the comparison controller can use them.

      let allResults: LenderResultMinimalDTO[] = [];
      this.matchingResults.forEach((result) => {
        allResults.push(result);
      });
      this.largestResults.forEach((result) => {
        allResults.push(result);
      });

      sessionStorage.setItem("TempSavedResults", JSON.stringify(allResults));

      if (this.searchid && this.caseid) {
        this.$location.path("compare/" + this.searchid + "/" + this.caseid);
      } else if (this.searchid) {
        this.$location.path("compare/" + this.searchid);
      } else {
        this.$location.path("compare/");
      }
    }
  }

  viewSingleLoan(item: LenderResultSummaryDTO) {
    event.preventDefault(); // prevents default behaviour of href
    this.warningOff = true;

    //Removed in favour of summaryComparisonList
    //this.comparisonList = [];

    //// Find Lender offer within the original arrays to use on the compare view
    //var match = this.getLenderResultMinimalDTO(item);

    //this.comparisonList.push(match);

    this.summaryComparisonList = [];
    this.summaryComparisonList.push(item);

    this.goCompare();
    (this.$rootScope as any).loanCriteria = this.loanCriteria;
  }

  /**
   * Processes the clicking of the "View Eligibility" anchor/button and index to show on the row number
   * @param item and index
   */
  viewEligibility(item: LenderResultSummaryDTO) {
    event.preventDefault(); // prevents default behaviour of href
    this.showProductNote = true;
    this.offer = item;
    this.loanLabel = item.loanLabel;
    this.productNote = item.additionalProductInfo;
  }

  returnToCase() {
    if (this.comparisonList.length > 0) {
      this.loadingData = true;
      this.loanCriteria.saveQueryAndResults = true;
      this.lenderResultClient
        .productsOfferingLargestLoanAndMatching(
          true,
          true,
          0,
          false,
          "",
          "",
          "",
          this.GetSelectedLabel(),
          true,
          this.loanCriteria,
        )
        .then((response) => {
          if (this.isShortlistingMore) {
            // copy newly selected products/lenders to caselender
            this.caseClient.shortlistMoreLenders(this.caseid, this.hasSearchChanged).then((response) => {
              this.$location.path("/casedashboard/" + this.caseid);
            });
          } else {
            this.$location.path("/casedashboard/" + this.caseid);
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    } else {
      this.$location.path("/casedashboard/" + this.caseid);
    }
  }

  go(path): void {
    this.$location.path(path);
  }
  goWarningOff(path): void {
    this.warningOff = true;
    LoginController.searchInProgress = true;
    (this.$rootScope as any).loginRedirectPath = this.$location.url();
    this.go(path);
  }

  backToClientSearches(): void {
    (this.$rootScope as any).clientUsernameBeingViewed = this.loanCriteria.ownerUser;
    this.$auth.clearSelectedNavMenuAndFilterStorageData();
    this.go("/userdashboard");
  }

  //setSelectedResultsFromComparisonList() {
  //    this.loanCriteria.selectedResults = this.comparisonList.map((item, index) => {
  //        return {
  //            DevelopmentInputId: item.DevelopmentInputID,
  //            ProductId: item.SeniorProductID,
  //            MenuId: null
  //        } as SelectedResult;
  //    });
  //}

  async register(
    createCase: boolean = false,
    productResultList: number,
    introducingAClient?: boolean,
    preventRedirect?: boolean,
  ) {
    this.loadingData = true;
    this.isProceedClicked = true;
    // Set the selected or "preferred" result.
    productResultList = this.productResultList;

    //this.setSelectedResultsFromComparisonList();
    (this.$rootScope as any).productResultList = productResultList;
    if (!(await this.indexService.currentUserId) || (await this.indexService.currentUserId) === null) {
      (this.$rootScope as any).selectedResultForAttachingToCase = this.selectedResultForAttachingToCase;
      this.loanCriteria.saveCase = createCase;
      (this.$rootScope as any).loanCriteria = this.loanCriteria;
      var path: string = "/register";

      if (
        this.$routeParams.brokerOrgUniqueRef !== undefined &&
        this.$routeParams.brokerOrgUniqueRef != "null" &&
        this.$routeParams.brokerUserId !== undefined &&
        this.$routeParams.brokerUserId != "null"
      ) {
        path += "/" + this.$routeParams.brokerOrgUniqueRef + "/" + this.$routeParams.brokerUserId;
      }

      this.$location.path(path);
    } else {
      this.loanCriteria.userId = this.loanCriteria.userId ? this.loanCriteria.userId : this.selectedUser.id;
      this.loanCriteria.saveQueryAndResults = true;
      this.loanCriteria.saveCase = createCase;
      if (this.isLender) {
        this.loanCriteria.lenderUserId = this.selectedUser.id;
      }
      // if broker info has been sent to the page then set this to the search
      if (this.$routeParams.brokerOrgUniqueRef !== undefined && this.$routeParams.brokerOrgUniqueRef != "null") {
        this.organisationClient
          .findOrganisationIdByUniqueRef(this.$routeParams.brokerOrgUniqueRef)
          .then((orgId: number) => {
            this.loanCriteria.brokerOrganisationId = orgId;

            if (this.$routeParams.brokerUserId !== undefined && this.$routeParams.brokerUserId != "null") {
              this.loanCriteria.brokerUserId = this.$routeParams.brokerUserId;
            } else {
              this.odataHelper
                .getOne(this.applicationUserCrudClient, {
                  filter: {
                    and: [{ organisationId: { eq: orgId } }, { isOrganisationAdmin: { eq: true } }],
                  },
                  select: { id: true },
                })
                .then((response) => {
                  this.loanCriteria.brokerUserId = response.id;
                });
            }

            // Save Search
            this.saveSearch(createCase, productResultList, preventRedirect);
          });
      } else {
        // Save Search
        this.saveSearch(createCase, productResultList, preventRedirect);
      }
      if (createCase == true) {
        this.loanCriteria.isFullCase = true;
        (this.$rootScope as any).loanCriteria = this.loanCriteria;
      }
    }
  }

  saveSearch(createCase: boolean, productResultList: number, preventRedirect?: boolean) {
    if (this.selectedResultForAttachingToCase) {
      this.loanCriteria.selectedProduct = this.selectedResultForAttachingToCase.lI_LoanProduct;
    }
    this.loadingData = true;
    // We always want to save at this point.
    this.loanCriteria.saveQueryAndResults = true;
    if (this.searchName != null && this.searchName.length > 0) {
      this.loanCriteria.searchName = this.searchName;
    }
    this.lenderResultClient
      .productsOfferingLargestLoanAndMatching(
        true,
        true,
        0,
        false,
        "",
        "",
        "",
        this.GetSelectedLabel(),
        true,
        this.loanCriteria,
      )
      .then((response) => {
        this.tempLoanCriteria = { ...this.loanCriteria };
        if (createCase === true) {
          //case creation
          //this.sendEnquiry();
          this.caseClient
            .promoteAndUpdateToDeal(
              response.id,
              this.selectedResultForAttachingToCase.lI_LoanProduct,
              productResultList,
            )
            .then((newCaseId) => {
              var expiryDate = new Date();
              expiryDate.setDate(expiryDate.getDate() + 365);
              this.$cookies.remove("caseLandingDontShowAgain");
              if (newCaseId) {
                this.$location.path("/devfinancecasedashboard/" + newCaseId + "/" + true);
              } else {
                this.isProceedClicked = false;
              }
              //});
            })
            .catch((response) => {
              this.isProceedClicked = false;
            });
        } else {
          //if (introducingAClient) {
          //    this.introducerSendResultsToClient(response.Id);
          //} else {

          if (!preventRedirect) {
            if ((this.isSaveorSaveAsClicked || this.isSaveClientSearch) && this.selectedUser.temporaryAccount != true) {
              this.doubleWarningOff = true;
              this.showSaveResults = null;

              if (this.prevPath) {
                this.$location.path(this.prevPath);
              } else {
                this.$location.path("/results/" + response.id);
              }
            } else {
              this.$auth.clearSelectedNavMenuAndFilterStorageData();
              this.$location.path("/userdashboard");
            }
          }

          //}
        }
      })
      .catch((response) => {
        this.isProceedClicked = false;
      })
      .finally(() => {
        this.loadingData = false;
        this.isClicked = false;
        this.isProceedClicked = false;
        this.newSearch = false;
      });
  }

  // TODO JLH - don't think this is in use
  sendEnquiry(): void {
    this.sendingmessage = true;
    this.sentmessage = false;
    this.enquiryTelephone = this.selectedUser.phoneNumber;
    this.enquiryEmail = this.selectedUser.email;
    this.enquiryBody = "Please send me more information about loan option " + this.GetSelectedLabel();
    this.lenderResultClient
      .productsOfferingLargestLoanAndMatching(
        true,
        true,
        0,
        true,
        this.enquiryBody,
        this.enquiryEmail,
        this.enquiryTelephone,
        this.GetSelectedLabel(),
        true,
        this.loanCriteria,
      )
      .then((response2) => {
        this.sendingmessage = false;
        this.sentmessage = true;
      });
  }

  private GetSelectedLabel() {
    var selectedlabel = "";
    if (this.selectedResultForAttachingToCase && this.selectedResultForAttachingToCase.loanLabel) {
      selectedlabel = this.selectedResultForAttachingToCase.loanLabel;
    }
    return selectedlabel;
  }

  applyForLoan(offer, productResultList: number) {
    /** This will check if the result shared with new user is active */
    const isActive = this.isResultActive();
    if (isActive) {
      //this.productResultList = productResultList;
      //this.SetSelectedItem(offer);
      if (this.searchid && this.loanCriteria.searchName.startsWith("My Development Finance Search")) {
        this.showSaveResults = 2;
      } else if (this.searchid) {
        this.register(true, this.productResultList);
      } else {
        if (
          this.clientFirstName != null ||
          this.clientSurname != null ||
          this.clientEmail != null ||
          this.clientPhoneNumber != null
        ) {
          this.loanCriteria.introduceeFirstName = this.clientFirstName;
          this.loanCriteria.introduceeSurname = this.clientSurname;
          this.loanCriteria.introduceeEmail = this.clientEmail;
          this.loanCriteria.introduceePhone = this.clientPhoneNumber;
        }

        this.showSaveResults = 2;
      }
    }
  }

  showSaveResultsPopup() {
    this.showSaveResults = 1;
  }

  showSaveCasePopup() {
    this.showSaveResults = 2;
  }

  changeSearch() {
    (this.$rootScope as any).loanCriteria = this.loanCriteria;
    (this.$rootScope as any).snapshotLoanCriteria = this.loanCriteria;
    this.warningOff = true;
    sessionStorage.setItem("skip", "true");
    if (this.caseid) {
      this.go("/criteria/" + this.searchid + "/" + this.caseid);
    } else if (this.searchid) {
      this.go("/criteria/" + this.searchid);
    } else if (this.isreferredSearch) {
      this.$location.path("/referredsearchcriteria/" + this.$routeParams.uniqueId + "/" + 0 + "/" + 1);
    } else {
      this.go("/criteria");
    }
  }

  debugSearch() {
    const stringJSON = JSON.stringify(this.loanCriteria);
    navigator.clipboard
      .writeText(stringJSON)
      .then()
      .catch((e) => console.log(e));
  }

  /**Processing for Net Loan Required input field OnBlur */
  netLoanRequiredOnBlur() {
    //wait to the debounce to update ng-model
    setTimeout(() => {
      // When the Net Loan required amount is empty or 0 then set the Maximum Loan required toggle to TRUE
      if (
        !this.loanCriteria.cI_Dev_LoanReq ||
        this.loanCriteria.cI_Dev_LoanReq == 0 ||
        String(this.loanCriteria.cI_Dev_LoanReq) == ""
      ) {
        this.isMaximumLoanRequired = true;
      }
    }, 1000);
  }

  updateSearchViaSlider(isAdminDebugValueChanged: boolean = false): void {
    /** This will check if the result shared with new user is active */
    var isActive = this.isResultActive();
    if (isActive && !this.showPostcodeErrorMessage) {
      this.loadingData = true;

      // Set criteria properties to 0 that have been cleared by the user e.g. backspace or delete has been used
      if (
        (!this.loanCriteria.cI_Dev_LoanReq && this.loanCriteria.cI_Dev_LoanReq != 0) ||
        String(this.loanCriteria.cI_Dev_LoanReq) == ""
      ) {
        this.loanCriteria.cI_Dev_LoanReq = 0;
      }

      if (
        (!this.loanCriteria.cI_Dev_LoanTermReq && this.loanCriteria.cI_Dev_LoanTermReq != 0) ||
        String(this.loanCriteria.cI_Dev_LoanTermReq) == ""
      ) {
        this.loanCriteria.cI_Dev_LoanTermReq = 0;
      }

      if (
        (!this.loanCriteria.cI_Dev_BuildTerm && this.loanCriteria.cI_Dev_BuildTerm != 0) ||
        String(this.loanCriteria.cI_Dev_BuildTerm) == ""
      ) {
        this.loanCriteria.cI_Dev_BuildTerm = 0;
      }

      if ((!this.loanCriteria.cI_GDV && this.loanCriteria.cI_GDV != 0) || String(this.loanCriteria.cI_GDV) == "") {
        this.loanCriteria.cI_GDV = 0;
      }

      if (
        (!this.loanCriteria.cI_Dev_BuildCosts && this.loanCriteria.cI_Dev_BuildCosts != 0) ||
        String(this.loanCriteria.cI_Dev_BuildCosts) == ""
      ) {
        this.loanCriteria.cI_Dev_BuildCosts = 0;
      }

      this.updatedResultsWithSlider = this.hasSearchChanged = this.hasCriteriaChanged = true;

      if (isAdminDebugValueChanged && this.isAdmin) {
        this.hasCriteriaChanged = false;
      }

      this.clearSelected();

      this.updateResults();
    }
  }

  clearSelected() {
    this.comparisonList = [];

    this.loanCriteria.selectedResults = [];
  }

  cancelSavePopup() {
    this.showSaveResults = null;
    this.loanCriteria.searchName = this.searchNameCache;
  }

  /* saveAs() {
            this.isClicked = true;
            this.isSaveorSaveAsClicked = true;
            delete this.loanCriteria.id;
            delete this.loanCriteria.isFullCase;
            delete this.loanCriteria.uniqueRef;
            this.register(false, this.productResultList);
        }*/

  doRenameSearch() {
    //this.register(false, this.productResultList, false, true);
    if (this.$routeParams.SearchId) {
      this.developmentInputClient.addUpdate(this.loanCriteria).then((response) => {
        this.toggleEditSearchName = false;
      });
    } else if (this.$routeParams.uniqueId !== undefined && this.$routeParams.uniqueId != "null") {
      var result = {} as DevelopmentInputWithNoLogin;
      (<any>Object).assign(result, this.loanCriteria);
      this.developmentInputWithNoLoginClient
        .saveChangesToReferredSearch(this.$routeParams.uniqueId, result)
        .then((response) => {
          this.toggleEditSearchName = false;
        });
    } else {
      this.toggleEditSearchName = false;
    }
  }

  emailChange() {
    if (this.error) {
      this.error = "";
    }
  }

  videotour() {
    this.showVideo = true;
  }

  videopause(id) {
    this.showVideo = false;
    let containerElement = document.getElementById(id);
    let iframe_tag = containerElement.querySelector("iframe");
    if (iframe_tag) {
      let iframeSrc = iframe_tag.src;
      iframe_tag.src = iframeSrc;
    }
  }

  updateLoanRequiredValue() {
    if (this.isMaximumLoanRequired) {
      if (this.loanCriteria.cI_Dev_LoanReq) {
        this.tempLoanRequired = this.loanCriteria.cI_Dev_LoanReq;
      }
      this.loanCriteria.cI_Dev_LoanReq = 0;
      this.updateSearchViaSlider();
    } else {
      this.loanCriteria.cI_Dev_LoanReq = this.tempLoanRequired;
      this.updateSearchViaSlider();
    }
  }

  /**
   * Finds the product in the Summary DTO and matches it to the original LenderResultMinimalDTOs
   * This is needed following the resdesign of the Search Results view and to keep the other views
   * functioning with minimal refactoring/impact
   * @param summaryDTO
   */
  getLenderResultMinimalDTO(summaryDTO: LenderResultSummaryDTO) {
    // Find Lender offer within the original arrays to use on the compare view
    let match: LenderResultMinimalDTO;
    if (summaryDTO.isMatching === true) {
      match = this.matchingResults.find((result) => result.seniorProductID === summaryDTO.productID);
    } else if (summaryDTO.isMatching === false) {
      match = this.largestResults.find((result) => result.seniorProductID === summaryDTO.productID);
    }

    // Overriding the loan label with the Lender Generic name
    match.loanLabel = summaryDTO.loanLabel;

    return match;
  }

  CalcProfessionalCostsAndCharges(): number {
    if (this.loanCriteria) {
      var res: number = 0;
      if (this.loanCriteria.dI_BreakDownBuildCosts) {
        if (this.loanCriteria.cI_Dev_ProfPlanning) {
          res += Number(this.loanCriteria.cI_Dev_ProfPlanning);
        }
        if (this.loanCriteria.cI_Dev_ProfQS) {
          res += Number(this.loanCriteria.cI_Dev_ProfQS);
        }
        if (this.loanCriteria.dI_BuildProjectManag) {
          res += Number(this.loanCriteria.dI_BuildProjectManag);
        }
        if (this.loanCriteria.cI_Dev_S106CIL) {
          res += Number(this.loanCriteria.cI_Dev_S106CIL);
        }
        if (this.loanCriteria.dI_BuildMechEng) {
          res += Number(this.loanCriteria.dI_BuildMechEng);
        }
        if (this.loanCriteria.dI_BuildStrucEng) {
          res += Number(this.loanCriteria.dI_BuildStrucEng);
        }
        if (this.loanCriteria.dI_BuildPartyWall) {
          res += Number(this.loanCriteria.dI_BuildPartyWall);
        }
        if (this.loanCriteria.dI_BuildLandscaping) {
          res += Number(this.loanCriteria.dI_BuildLandscaping);
        }
        if (this.loanCriteria.dI_BuildWarranty) {
          res += Number(this.loanCriteria.dI_BuildWarranty);
        }
        if (this.loanCriteria.dI_BuildDemolition) {
          res += Number(this.loanCriteria.dI_BuildDemolition);
        }
        if (this.loanCriteria.dI_BuildOtherCosts) {
          res += Number(this.loanCriteria.dI_BuildOtherCosts);
        }
      } else {
        if (this.loanCriteria.cI_Dev_AdditionalOngoingCosts) {
          res += Number(this.loanCriteria.cI_Dev_AdditionalOngoingCosts);
        }
      }

      return res;
    }
  }

  CalcPurchaseAdditionalCosts(): number {
    if (this.loanCriteria) {
      var res: number = 0;

      if (this.loanCriteria.cI_Dev_SDLT) {
        res += Number(this.loanCriteria.cI_Dev_SDLT);
      }
      if (this.loanCriteria.dI_PurchaseAgentFees) {
        res += Number(this.loanCriteria.dI_PurchaseAgentFees);
      }
      if (this.loanCriteria.dI_PurchaseLegalFees) {
        res += Number(this.loanCriteria.dI_PurchaseLegalFees);
      }
      if (this.loanCriteria.dI_PurchaseOtherFees) {
        res += Number(this.loanCriteria.dI_PurchaseOtherFees);
      }

      return res;
    }
  }

  /**Close the search summary panel */
  showSearchSummary(show: boolean) {
    (this.$rootScope as any).hideSearchSummary = !show;
    this.sliderShown = show;
  }

  contingencyChanged() {
    this.recalcCosts("CI_Dev_Contingency");
    this.updateSearchViaSlider();
  }

  getSearchResultCount() {
    if (this.summarySearchResults) {
      return this.summarySearchResults.length;
    } else {
      return 0;
    }
  }

  getSearchLenderCount() {
    this.lenderClient.getTotalLenders(ProductFamilyEnum.Development).then((result) => {
      this.totalLender = result;
    });
  }

  /** user lookup for newsearch popup */
  userLookupForNewSearch(userSearchTerm: string) {
    this.loadingData = true;
    this.odataHelper
      .getMany(this.applicationUserCrudClient, {
        filter: {
          email: {
            contains: userSearchTerm,
          },
        },
      })
      .then((response) => {
        if (this.isBroker) {
          this.existingUsers = response.filter(
            (x) =>
              x.organisationReferralId == this.selectedUser.organisationId &&
              !x.organisationId &&
              !x.isOrganisationAdmin,
          );
        } else {
          this.existingUsers = response;
        }
      })
      .finally(() => {
        this.loadingData = false;
      });
  }

  /** closes new search pop up*/
  cancelNewSearch() {
    this.newSearch = false;
    delete this.clientFirstName;
    delete this.clientEmail;
    delete this.clientSurname;
    delete this.clientPhoneNumber;
    delete this.clientId;
    this.existingborrower = null;
    this.showClientDetails = false;
    this.selecteduserName = null;
    this.sharedSearch = false;
    if (this.tempSearchName) {
      this.loanCriteria.searchName = this.tempSearchName;
      this.tempSearchName = "";
    }
  }

  sendResultsToClient(notifyBorrower, reloadSearch = false) {
    if (this.isSaveAsClicked) {
      this.saveSaveAsSearch(true);
    } else {
      this.loadingData = true;
      this.newSearch = false;
      this.existingborrower = null;
      this.showClientDetails = false;
      if (this.searchName != null && this.searchName.length > 0) {
        this.loanCriteria.searchName = this.searchName;
      }

      this.userClient
        .getUserDetailsByEmailIfExists(this.clientEmail)
        .then((user: ApplicationUser) => {
          if (user == null) {
            this.loanCriteria.userId = null;
            this.introducerClient
              .sendResultsToClient(
                this.clientFirstName,
                this.clientSurname,
                this.clientEmail,
                notifyBorrower,
                this.clientPhoneNumber,
                this.loanCriteria,
              )
              .then((success) => {
                this.searchReference = success;
                if (reloadSearch) {
                  this.warningOff = true;
                  this.go("/referredSearch/" + this.searchReference);
                } else {
                  this.showSaveResults = 6;
                }
              });
          } else {
            this.loanCriteria.user = user;
            this.clientId = user.id;
            if (this.searchid) {
              this.developmentInputClient
                .sendResultsToExistingClient(
                  this.clientFirstName,
                  this.clientSurname,
                  this.clientEmail,
                  this.clientId,
                  notifyBorrower,
                  this.clientPhoneNumber,
                  this.loanCriteria,
                )
                .then((success) => {
                  this.newSearchId = success;
                  if (reloadSearch) {
                    this.warningOff = true;
                    this.go("/results/" + this.newSearchId);
                  } else {
                    this.showSaveResults = 7;
                  }
                });
            } else {
              const result = {} as DevelopmentInputWithNoLogin;
              (<any>Object).assign(result, this.loanCriteria);
              this.developmentInputWithNoLoginClient
                .sendResultsToExistingClient(
                  this.clientFirstName,
                  this.clientSurname,
                  this.clientEmail,
                  this.clientId,
                  notifyBorrower,
                  this.clientPhoneNumber,
                  result,
                )
                .then((success) => {
                  this.newSearchId = success;
                  if (reloadSearch) {
                    this.warningOff = true;
                    this.go("/results/" + this.newSearchId);
                  } else {
                    this.showSaveResults = 7;
                  }
                });
            }
          }
        })
        .finally(() => {
          delete this.clientFirstName;
          delete this.clientEmail;
          delete this.clientSurname;
          delete this.clientPhoneNumber;
          delete this.clientId;
          this.loadingData = false;
        });
    }
  }

  /*  sendResultsToExistingClient(notifyBorrower: boolean = true) {

            this.developmentInputClient.sendResultsToExistingClient(this.loanCriteria, this.clientFirstName, this.clientSurname, this.clientEmail, this.clientId, notifyBorrower, this.clientPhoneNumber).then((success) => {
                this.newSearchId = success;
                this.loadingData = false;
                delete this.clientFirstName;
                delete this.clientEmail;
                delete this.clientSurname;
                delete this.clientPhoneNumber;
                delete this.clientId;
                this.showSaveResults = 7;              
            });
        }

        introducerSendResultsToClient(notifyBorrower: boolean = true) {
            // remove the user id because otherwise the client won't be able to see the search on their dashboard
            this.loanCriteria.userId = null;
            this.introducerClient.sendResultsToClient(this.loanCriteria, this.clientFirstName, this.clientSurname, this.clientEmail, notifyBorrower, this.clientPhoneNumber).then((success) => {
                this.loadingData = false;
                delete this.clientFirstName;
                delete this.clientEmail;
                delete this.clientSurname;
                delete this.clientPhoneNumber;

                if (this.isBroker) {
                    this.searchReference = success;
                    this.showSaveResults = 6;
                } else {
                    this.showSaveResults = 5;
                }

            });
        }
        */

  viewClientsDashboardForNewSearch(userName: string) {
    //Look up client's account details
    this.loadingData = true;
    this.userClient.searchByEmail(userName).then((users) => {
      console.log(users);
      console.log(users[0].firstName);
      this.clientFirstName = users[0].firstName;
      this.clientEmail = users[0].email;
      this.clientSurname = users[0].lastName;
      this.clientPhoneNumber = users[0].phoneNumber;
      this.clientId = users[0].id;
      this.showClientDetails = true;
      this.loadingData = false;
    });
  }

  clearInputFields() {
    this.clientFirstName = null;
    this.clientEmail = null;
    this.clientSurname = null;
    this.clientPhoneNumber = null;
    this.showClientDetails = false;
    this.selecteduserName = null;
  }

  // These functions are for the FAQ slider

  toggleAccordion(id: number) {
    if (!this.accordionShow[id]) {
      this.accordionShow[id] = true;
    } else {
      this.accordionShow[id] = !this.accordionShow[id];
    }
  }

  requestEmail(reason): void {
    this.showRequestEmailForm = true;
    this.requestMessageReason = reason;
    this.message = true;
    this.messageContent = "";
  }

  closeModal() {
    this.message = false;
  }

  sendRequestEmail() {
    this.showRequestEmailForm = false;
    this.loadingData = true;
    this.sendingMessage = true;

    if (this.currentCase) {
      this.accountClient
        .requestAssistanceReview(this.requestMessageReason, this.currentCase.id, ProductFamilyEnum.None)
        .then((response) => {
          this.showMessage(
            `${this.appName} have been notified that you require assistance and will be in touch shortly to help.`,
          );

          let caseNote = {
            caseId: this.currentCase.id,
            userId: this.selectedUser.id,
            noteText: "You have requested " + this.requestMessageReason + ".",
            // expandNote: false,
          } as CaseNote;

          this.caseNoteClient.addUpdate(caseNote);
        })
        .catch((error) => {
          this.showMessage("Sorry, something went wrong while sending your email. Please try again.");
        })
        .finally(() => {
          this.sendingMessage = false;
          this.loadingData = false;
        });
    } else if (this.searchid) {
      this.lenderResultClient
        .requestAssistance(this.requestMessageReason, this.searchid)
        .then((response) => {
          this.showMessage(
            `${this.appName} have been notified that you require assistance and will be in touch shortly to help.`,
          );
        })
        .catch((error) => {
          this.showMessage("Sorry, something went wrong while sending your email. Please try again.");
        })
        .finally(() => {
          this.sendingMessage = false;
          this.loadingData = false;
        });
    }
  }

  showMessage(message: string) {
    this.messageContent = message;
  }

  hideRequestAssistance(): boolean {
    return !this.searchid;
  }

  // End of functions for the FAQ slider

  getAppName() {
    let lsd = null;
    if (window.self == window.top) lsd = sessionStorage.getItem("applicationName");
    if (lsd != null) {
      this.appName = lsd;
    } else {
      this.appName = "Brickflow";
    }
  }

  defaultSearchName() {
    var currentdate = new Date();
    return (
      "My Development Finance Search " +
      currentdate.getDate() +
      "/" +
      (currentdate.getMonth() + 1) +
      "/" +
      currentdate.getFullYear()
    );
  }

  fillHalfRegisterForm() {
    let name = new Date().toLocaleString().replace(/ |,|:|\/|/g, "");
    this.newUser.email = `${name}@test.com`;
    this.newUser.firstName = name;
    this.newUser.lastName = "t";
    this.newUser.phoneNumber = "12345677";
    this.newUser.applicantDefinedRole = 0;
  }

  registerNow() {
    (this.$rootScope as any).loanCriteria = this.loanCriteria;
    this.cancelSaving();
    this.$location.path("promo");
  }

  sendShareSearchEmailToClient() {
    this.dataLoading = true;
    if (this.$routeParams.uniqueId) {
      this.developmentInputWithNoLoginClient.isResultActive(this.$routeParams.uniqueId).then((results) => {
        if (results) {
          this.developmentInputWithNoLoginClient
            .sendEmailToNewUser(this.$routeParams.uniqueId, this.loanCriteria.showLenderNamesToBorrower, true)
            .then((response) => {
              this.displayMsg =
                "Search results have been sent to " +
                this.loanCriteria.introduceeFirstName +
                " " +
                this.loanCriteria.introduceeSurname;
              this.newSearch = false;
              this.showMsg = true;
              this.dataLoading = false;
            })
            .catch((error) => {
              this.displayMsg = "Sorry, something went wrong. Please try again.";
              this.newSearch = false;
              this.showMsg = true;
              this.dataLoading = false;
            });
        } else {
          this.displayMsg = `Changes have been made to this search by your client, you will now be taken back to your user dashboard`;
          this.newSearch = false;
          this.showMsgToAdminOrBroker = true;
          this.dataLoading = false;
        }
      });
    } else {
      this.developmentInputClient
        .sendEmailToExistingUser(this.$routeParams.SearchId, this.loanCriteria.showLenderNamesToBorrower, true)
        .then((response) => {
          this.displayMsg =
            "Search results have been sent to " +
            this.loanCriteria.introduceeFirstName +
            " " +
            this.loanCriteria.introduceeSurname;
          this.newSearch = false;
          this.showMsg = true;
          this.dataLoading = false;
        })
        .catch((error) => {
          this.displayMsg = "Sorry, something went wrong. Please try again.";
          this.newSearch = false;
          this.newSearch = false;
          this.showMsg = true;
          this.dataLoading = false;
        });
    }
  }

  deleteSearch() {
    if (this.$routeParams.SearchId) {
      this.developmentInputClient
        .markAsDeleted(this.$routeParams.SearchId)
        .then((response) => {
          this.displayMsg = "Search is successfully deleted";
          this.showMsg = true;
          this.ShowdeleteSearch = true;
        })
        .catch((error) => {
          this.displayMsg = "Sorry, something went wrong. Please try again.";
          this.showMsg = true;
        });
    } else {
      /** This will check if the result shared with new user is active */
      this.developmentInputWithNoLoginClient.isResultActive(this.$routeParams.uniqueId).then((results) => {
        if (!results) {
          this.displayMsg = `Changes have been made to this search by your client, you will now be taken back to your user dashboard`;
          this.showMsgToAdminOrBroker = true;
        } else {
          this.developmentInputWithNoLoginClient
            .markAsDeleted(this.loanCriteria.id)
            .then((response) => {
              this.displayMsg = "Search is successfully  deleted";
              this.showMsg = true;
              this.ShowdeleteSearch = true;
            })
            .catch((error) => {
              this.displayMsg = "Sorry, something went wrong. Please try again.";
              this.showMsg = true;
            });
        }
      });
    }
  }

  closeDeleteModal() {
    this.showMsg = false;
    this.displayMsg = null;
    this.ShowdeleteSearch = false;
    this.warningOff = true;
    this.$auth.clearSelectedNavMenuAndFilterStorageData();
    this.go("/userdashboard");
  }

  onDIPClick(item: LenderResultSummaryDTO) {
    this.isDIPClicked = true;

    this.toggleLenderComparisonSelection(item);

    if (this.searchid && this.loanCriteria.searchName.startsWith("My Loan Search")) {
      this.showSaveResults = 2;
    } else if (this.searchid) {
      this.register(true, this.productResultList);
      this.warningOff = false;
    } else if (this.loanCriteria.searchName) {
      this.register(true, this.productResultList);
      this.doubleWarningOff = true;
    } else {
      this.showSaveResults = 2;
    }
  }

  /* onClickSaveAs() {
            this.showSaveResults = 3;
            this.tempSearchName = this.loanCriteria.searchName;
            this.loanCriteria.searchName = '';
        }*/

  onClickSaveAs() {
    this.isSaveAsClicked = true;
    if (this.isAdmin || this.isBroker) {
      this.tempSearchName = this.loanCriteria.searchName;
      this.loanCriteria.searchName = "";
      this.showShareSearchModal();
    } else {
      this.showSaveResults = 3;
    }
  }

  saveAsWthOutIntroducee() {
    this.isSaveAsWthOutIntroducee = true;
    this.tempSearchName = this.loanCriteria.searchName;
    this.loanCriteria.searchName = "";
    this.showShareSearchModal();
  }

  saveChangesToReferredSearch() {
    var result = {} as DevelopmentInputWithNoLogin;
    this.loadingData = true;
    (<any>Object).assign(result, this.loanCriteria);
    this.developmentInputWithNoLoginClient
      .saveChangesToReferredSearch(this.$routeParams.uniqueId, result, false)
      .then((savedSearchId) => {
        this.loadingData = false;
      });
  }

  getUsersBelongToBrokerOrAdmin() {
    this.loadingData = true;
    this.userClient.getUserSummariesForBrokerOrAdmin().then((response) => {
      this.existingUsers = response;
    });
  }

  saveResultsClicked() {
    if (this.prevPath) {
      this.isSaveorSaveAsClicked = false;
    } else {
      this.isSaveorSaveAsClicked = true;
    }
    this.register(false, this.productResultList);
  }

  checkShowBridgingEligibility() {
    return this.staticDataClient.getShowBridgingEligibility();
  }

  showBookMeetingButton() {
    return !this.isLoggedInUser && this.isClient && this.brokerDetail == "" && this.brokerageOrg != null;
  }

  bookMeeting() {
    this.staticDataClient.getHubspotDeveloperBookMeetingWithSearch().then((hubSpotUrl: string) => {
      window.open(hubSpotUrl);
    });
  }

  onShareholderDepositRequiredChange(e: ShareholderDepositRequiredEnum) {
    switch (e) {
      case ShareholderDepositRequiredEnum.None:
        this.loanCriteria.f_ShareholderDepositRequired = 0;
        break;
      case ShareholderDepositRequiredEnum.UpTo25Percent:
        this.loanCriteria.f_ShareholderDepositRequired = 0.25;
        break;
      case ShareholderDepositRequiredEnum.TwentyFiveTo50Percent:
        this.loanCriteria.f_ShareholderDepositRequired = 0.5;
        break;
      case ShareholderDepositRequiredEnum.FiftyPercentPlus:
        this.loanCriteria.f_ShareholderDepositRequired = 1.0;
        break;
      default:
        this.loanCriteria.f_ShareholderDepositRequired = null;
        break;
    }
  }

  getShareholderDepositRequired() {
    var value = null;
    switch (this.loanCriteria.f_ShareholderDepositRequired) {
      case 0:
        value = ShareholderDepositRequiredEnum.None;
        break;
      case 0.25:
        value = ShareholderDepositRequiredEnum.UpTo25Percent;
        break;
      case 0.5:
        value = ShareholderDepositRequiredEnum.TwentyFiveTo50Percent;
        break;
      case 1.0:
        value = ShareholderDepositRequiredEnum.FiftyPercentPlus;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  getPreviousDevelopments() {
    var value = null;
    switch (this.loanCriteria.f_NumberOfPreviousDevelopments) {
      case 1:
        value = PreviousDevelopmentsEnum.One;
        break;
      case 2:
        value = PreviousDevelopmentsEnum.Two;
        break;
      case 3:
        value = PreviousDevelopmentsEnum.Three;
        break;
      case 4:
        value = PreviousDevelopmentsEnum.FourOrMore;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  onPersonalGuaranteeLevelOptionsChange(e: PersonalGuaranteeLevelEnum) {
    switch (e) {
      case PersonalGuaranteeLevelEnum.UpTo20Percent:
        this.loanCriteria.f_PersonalGuaranteeLevel = 0.2;
        break;
      case PersonalGuaranteeLevelEnum.TwentyOneTo35Percent:
        this.loanCriteria.f_PersonalGuaranteeLevel = 0.35;
        break;
      case PersonalGuaranteeLevelEnum.ThirtySixTo50Percent:
        this.loanCriteria.f_PersonalGuaranteeLevel = 0.5;
        break;
      case PersonalGuaranteeLevelEnum.OneHundredPercent:
        this.loanCriteria.f_PersonalGuaranteeLevel = 1.0;
        break;
      default:
        this.loanCriteria.f_PersonalGuaranteeLevel = null;
        break;
    }
  }

  getPersonalGuaranteeLevelOptions() {
    var value = null;
    switch (this.loanCriteria.f_PersonalGuaranteeLevel) {
      case 0.2:
        value = PersonalGuaranteeLevelEnum.UpTo20Percent;
        break;
      case 0.35:
        value = PersonalGuaranteeLevelEnum.TwentyOneTo35Percent;
        break;
      case 0.5:
        value = PersonalGuaranteeLevelEnum.ThirtySixTo50Percent;
        break;
      case 1.0:
        value = PersonalGuaranteeLevelEnum.OneHundredPercent;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  onMaxHouseSalesPriceChange(e: MaxHouseSalePriceEnum) {
    switch (e) {
      case MaxHouseSalePriceEnum.UpTo1Million:
        this.loanCriteria.f_MaxHouseSalesPrice = 1000000;
        break;
      case MaxHouseSalePriceEnum.UpTo2Million:
        this.loanCriteria.f_MaxHouseSalesPrice = 2000000;
        break;
      case MaxHouseSalePriceEnum.UpTo5Million:
        this.loanCriteria.f_MaxHouseSalesPrice = 5000000;
        break;
      case MaxHouseSalePriceEnum.NoMax:
        this.loanCriteria.f_MaxHouseSalesPrice = -999;
        break;
      default:
        this.loanCriteria.f_MaxHouseSalesPrice = null;
        break;
    }
  }

  getMaxHouseSalesPrice() {
    var value = null;
    switch (this.loanCriteria.f_MaxHouseSalesPrice) {
      case 1000000:
        value = MaxHouseSalePriceEnum.UpTo1Million;
        break;
      case 2000000:
        value = MaxHouseSalePriceEnum.UpTo2Million;
        break;
      case 5000000:
        value = MaxHouseSalePriceEnum.UpTo5Million;
        break;
      case -999:
        value = MaxHouseSalePriceEnum.NoMax;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  onMaxFlatUnitPriceChange(e: MaxFlatUnitPriceEnum) {
    switch (e) {
      case MaxFlatUnitPriceEnum.UpTo1Million:
        this.loanCriteria.f_MaxFlatUnitPrice = 1000000;
        break;
      case MaxFlatUnitPriceEnum.UpTo2Million:
        this.loanCriteria.f_MaxFlatUnitPrice = 2000000;
        break;
      case MaxFlatUnitPriceEnum.UpTo3Million:
        this.loanCriteria.f_MaxFlatUnitPrice = 3000000;
        break;
      case MaxFlatUnitPriceEnum.NoMax:
        this.loanCriteria.f_MaxFlatUnitPrice = -999;
        break;
      default:
        this.loanCriteria.f_MaxFlatUnitPrice = null;
        break;
    }
  }

  getMaxFlatUnitPrice() {
    var value = null;
    switch (this.loanCriteria.f_MaxFlatUnitPrice) {
      case 1000000:
        value = MaxFlatUnitPriceEnum.UpTo1Million;
        break;
      case 2000000:
        value = MaxFlatUnitPriceEnum.UpTo2Million;
        break;
      case 3000000:
        value = MaxFlatUnitPriceEnum.UpTo3Million;
        break;
      case -999:
        value = MaxFlatUnitPriceEnum.NoMax;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  onMaxSqFtSalePriceChange(e: MaxSqFtSalePriceEnum) {
    switch (e) {
      case MaxSqFtSalePriceEnum.UpTo850:
        this.loanCriteria.f_MaxSqFtSalePrice = 850;
        break;
      case MaxSqFtSalePriceEnum.UpTo1000:
        this.loanCriteria.f_MaxSqFtSalePrice = 1000;
        break;
      case MaxSqFtSalePriceEnum.UpTo1500:
        this.loanCriteria.f_MaxSqFtSalePrice = 1500;
        break;
      case MaxSqFtSalePriceEnum.NoMax:
        this.loanCriteria.f_MaxSqFtSalePrice = -999;
        break;
      default:
        this.loanCriteria.f_MaxSqFtSalePrice = null;
        break;
    }
  }

  onMaxSqFtFlatsSalePriceChange(e: MaxSqFtSalePriceEnum) {
    switch (e) {
      case MaxSqFtSalePriceEnum.UpTo850:
        this.loanCriteria.f_MaxSqFtSalePriceFlats = 850;
        break;
      case MaxSqFtSalePriceEnum.UpTo1000:
        this.loanCriteria.f_MaxSqFtSalePriceFlats = 1000;
        break;
      case MaxSqFtSalePriceEnum.UpTo1500:
        this.loanCriteria.f_MaxSqFtSalePriceFlats = 1500;
        break;
      case MaxSqFtSalePriceEnum.NoMax:
        this.loanCriteria.f_MaxSqFtSalePriceFlats = -999;
        break;
      default:
        this.loanCriteria.f_MaxSqFtSalePriceFlats = null;
        break;
    }
  }

  getMaxSqFtSalePrice() {
    var value = null;
    switch (this.loanCriteria.f_MaxSqFtSalePrice) {
      case 850:
        value = MaxSqFtSalePriceEnum.UpTo850;
        break;
      case 1000:
        value = MaxSqFtSalePriceEnum.UpTo1000;
        break;
      case 1500:
        value = MaxSqFtSalePriceEnum.UpTo1500;
        break;
      case -999:
        value = MaxSqFtSalePriceEnum.NoMax;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  getMaxSqFtSalePriceFlats() {
    var value = null;
    switch (this.loanCriteria.f_MaxSqFtSalePriceFlats) {
      case 850:
        value = MaxSqFtSalePriceEnum.UpTo850;
        break;
      case 1000:
        value = MaxSqFtSalePriceEnum.UpTo1000;
        break;
      case 1500:
        value = MaxSqFtSalePriceEnum.UpTo1500;
        break;
      case -999:
        value = MaxSqFtSalePriceEnum.NoMax;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  applyFilters() {
    this.loadingData = true;
    this.showFilters = false;
    this.isFilterUpdate = true;
    this.clearSelected();
    this.updateResults();

    if (this.loanCriteria.id) {
      if (this.$routeParams.uniqueId !== undefined && this.$routeParams.uniqueId != "null") {
        var result = {} as DevelopmentInputWithNoLogin;
        (<any>Object).assign(result, this.loanCriteria);
        this.developmentInputWithNoLoginClient
          .saveChangesToReferredSearch(this.$routeParams.uniqueId, result, false)
          .catch((error) => {
            this.displayMsg = "Sorry, something went wrong and your filters were not saved. Please try again.";
            this.showMsg = true;
          });
      } else {
        this.developmentInputClient.saveSearch(this.loanCriteria).catch((error) => {
          this.displayMsg = "Sorry, something went wrong and your filters were not saved. Please try again.";
          this.showMsg = true;
        });
      }
    }
  }

  clearClientFilters() {
    this.loanCriteria.f_IsFirstTimeDeveloper = null;
    this.loanCriteria.f_NumberOfPreviousDevelopments = null;
    this.loanCriteria.f_ShareholderDepositRequired = null;
    this.shareholderDepositRequired = null;
    this.loanCriteria.f_IsPersonalName = null;
    this.loanCriteria.f_IsOffshoreCompany = null;
    this.loanCriteria.f_IsMainShareholderOverseas = null;
    this.loanCriteria.f_PersonalGuaranteeLevel = null;
    this.personalGuaranteeLevel = null;
    this.loanCriteria.f_HasAdverseCredit = null;
    this.loanCriteria.f_MaxCommercialFloorspace = null;
  }

  showClearForClientFilters() {
    if (
      this.loanCriteria.f_IsFirstTimeDeveloper != null ||
      this.loanCriteria.f_NumberOfPreviousDevelopments != null ||
      this.loanCriteria.f_ShareholderDepositRequired != null ||
      this.loanCriteria.f_IsPersonalName != null ||
      this.loanCriteria.f_IsOffshoreCompany != null ||
      this.loanCriteria.f_IsMainShareholderOverseas != null ||
      this.loanCriteria.f_PersonalGuaranteeLevel != null ||
      this.loanCriteria.f_HasAdverseCredit != null ||
      this.loanCriteria.f_MaxCommercialFloorspace != null
    ) {
      return true;
    } else {
      return false;
    }
  }

  clearPropertyFilters() {
    this.loanCriteria.f_IsAirRights = null;
    this.loanCriteria.f_IsModular = null;
    this.loanCriteria.f_IsPermittedDevelopmentScheme = null;
    this.loanCriteria.f_IsGradeOneListed = null;
    this.loanCriteria.f_IsGradeTwoListed = null;
    this.loanCriteria.f_MaxHouseSalesPrice = null;
    this.loanCriteria.f_MaxFlatUnitPrice = null;
    this.loanCriteria.f_MaxNumberOfUnits = null;
    //this.loanCriteria.f_MaxPercCommercialForMixedUse = null;
    this.loanCriteria.f_MaxSqFtSalePrice = null;
    this.loanCriteria.f_MaxSqFtSalePriceFlats = null;
    this.loanCriteria.f_IsWorkStarted = null;
    this.maxHouseSalesPrice = null;
    this.maxFlatUnitPrice = null;
    this.maxSqFtSalePrice = null;
    this.maxPercCommercialForMixedUse = null;
    this.maxSqFtSalePriceFlats = null;
    this.previousDevelopments = null;
  }

  showClearForPropertyFilters() {
    if (
      this.loanCriteria.f_IsAirRights != null ||
      this.loanCriteria.f_IsModular != null ||
      this.loanCriteria.f_IsPermittedDevelopmentScheme != null ||
      this.loanCriteria.f_IsGradeOneListed != null ||
      this.loanCriteria.f_IsGradeTwoListed != null ||
      this.loanCriteria.f_MaxHouseSalesPrice != null ||
      this.loanCriteria.f_MaxFlatUnitPrice != null ||
      this.loanCriteria.f_MaxNumberOfUnits != null ||
      //this.loanCriteria.f_MaxPercCommercialForMixedUse != null ||
      this.loanCriteria.f_MaxSqFtSalePrice != null ||
      this.loanCriteria.f_IsWorkStarted != null ||
      this.loanCriteria.f_MaxSqFtSalePriceFlats != null
    ) {
      return true;
    } else {
      return false;
    }
  }

  clearFinanceFilters() {
    this.loanCriteria.f_IsChargeOnAdditionalProperty = null;
    this.loanCriteria.f_IsFixedRate = null;
    this.loanCriteria.f_InterestRateBasis = null;
    this.loanCriteria.f_IsBank = null;
  }

  showClearForFinanceFilters() {
    if (
      this.loanCriteria.f_IsChargeOnAdditionalProperty != null ||
      this.loanCriteria.f_IsFixedRate != null ||
      this.loanCriteria.f_InterestRateBasis != null ||
      this.loanCriteria.f_IsBank != null
    ) {
      return true;
    } else {
      return false;
    }
  }

  clearAllFilters() {
    this.clearClientFilters();
    this.clearPropertyFilters();
    this.clearFinanceFilters();
  }

  checkFilterSelected(property: string) {
    let value = this.loanCriteria[property];
    if (typeof value === "boolean" && value === true) {
      return true;
    } else if (value != null && typeof value != "boolean") {
      return true;
    }
    return false;
  }

  filterPropertyToText(property: string) {
    let value = this.loanCriteria[property];
    if (typeof value == "boolean" && value == true) {
      return;
    } else if (value != null && typeof value != "boolean") {
      return `: ${this.getPropertyValue(property)}`;
    }
    return false;
  }

  getDisplayTextForProperty(property) {
    switch (property) {
      case "f_IsFirstTimeDeveloper":
        return "1st Time Dev";
      case "f_ShareholderDepositRequired":
        return "Shareholder Deposit";
      case "f_IsPersonalName":
        return "Personal Name";
      case "f_IsOffshoreCompany":
        return "Non-UK Company";
      case "f_IsMainShareholderOverseas":
        return "Client Based Overseas";
      case "f_PersonalGuaranteeLevel":
        return "PG";
      case "f_IsAirRights":
        return "Air Rights Scheme";
      case "f_IsModular":
        return "Modular";
      case "f_IsPermittedDevelopmentScheme":
        return "PD Scheme";
      case "f_IsGradeOneListed":
        return "Grade 1 Listed";
      case "f_IsGradeTwoListed":
        return "Grade 2 Listed";
      case "f_MaxHouseSalesPrice":
        return "Max Sales Price (Houses)";
      case "f_MaxSqFtSalePrice":
        return "Max £/sq.ft (Houses)";
      case "f_MaxSqFtSalePriceFlats":
        return "Max £/sq.ft (Flats)";
      case "f_MaxFlatUnitPrice":
        return "Max Sales Price (Flats)";
      // case "f_MaxPercCommercialForMixedUse":
      //   return "Max Commercial or Mixed Use";
      case "f_NumberOfPreviousDevelopments":
        return "Previous Developments";
      case "f_MaxNumberOfUnits":
        return `Max Units`;
      case "f_IsWorkStarted":
        return "Works Commenced";
      case "f_IsChargeOnAdditionalProperty":
        return "Additional Security";
      case "f_IsFixedRate":
        return "Fixed Rate";
      case "f_HasAdverseCredit":
        return "Adv. Credit";
      case "f_MaxCommercialFloorspace":
        return "Com. Floorspace (max %)";
      default:
        return "";
    }
  }

  getPropertyValue(property) {
    let propertyValue = this.loanCriteria[property];
    switch (property) {
      case "f_ShareholderDepositRequired":
        return this.selectListService
          .GetShareholderDepositRequired()
          .find((item) => item.key === this.getShareholderDepositRequired())?.displayName;
      case "f_PersonalGuaranteeLevel":
        return this.selectListService
          .GetPersonalGuaranteeLevels()
          .find((item) => item.key === this.getPersonalGuaranteeLevelOptions())?.displayName;
      case "f_MaxHouseSalesPrice":
        return this.selectListService.GetMaxHouseSalePrices().find((item) => item.key === this.getMaxHouseSalesPrice())
          ?.displayName;
      case "f_MaxFlatUnitPrice":
        return this.selectListService.GetMaxFlatUnitPrices().find((item) => item.key === this.getMaxFlatUnitPrice())
          ?.displayName;
      case "f_MaxSqFtSalePrice":
        return this.selectListService.GetMaxSqFtSalePrices().find((item) => item.key === this.getMaxSqFtSalePrice())
          ?.displayName;
      case "f_MaxSqFtSalePriceFlats":
        return this.selectListService
          .GetMaxSqFtSalePrices()
          .find((item) => item.key === this.getMaxSqFtSalePriceFlats())?.displayName;
      case "f_NumberOfPreviousDevelopments":
        return this.selectListService
          .GetNumberOfPreviousDevelopments()
          .find((item) => item.key === this.getPreviousDevelopments())?.displayName;
      case "f_MaxNumberOfUnits":
        return propertyValue;
      case "f_MaxCommercialFloorspace":
        return this.selectListService
          .GetMaxCommercialFloorspaceOptions()
          .find((item) => item.key === this.loanCriteria.f_MaxCommercialFloorspace)?.displayName;
      default:
        return propertyValue;
    }
  }

  countFiltersSelected() {
    let count = 0;
    if (this.loanCriteria) {
      this.filterProperties.forEach((property) => {
        if (this.checkFilterSelected(property)) {
          count++;
        }
      });
    }
    return count;
  }

  splitCamelCase(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/([A-Z])([A-Z][a-z])/g, "$1 $2");
  }

  showShareSearchModal() {
    this.newSearch = true;
    this.loanCriteria.showLenderNamesToBorrower = this.loanCriteria.showLenderInfoBrokerOverride;
  }

  isShareNoteFormComplete(): boolean {
    if (this.shareEmailSubject == "undefined" || this.shareEmailSubject == null || this.shareEmailSubject.length == 0) {
      return false;
    }
    if (this.shareNote == "undefined" || this.shareNote == null || this.shareNote.length == 0) {
      return false;
    }
    return true;
  }

  openSendToLender(item: LenderResultSummaryDTO) {
    this.shareFirstName = item.contactUserFirstName;
    this.lenderEmail = item.contactUserEmail;
    this.showContactLender = true;
  }

  /*sendToLender() {
    this.loadingData = true;
    this.$lenderresultservice
      .sendNoteToLender(this.lenderEmail, this.shareEmailSubject, this.shareNote)
      .then((success) => {
        this.showContactLender = false;
        this.loadingData = false;
      });
  }*/

  /** This will check if the result shared with new user is active */
  isResultActive() {
    if (this.$routeParams.uniqueId && this.isBroker) {
      this.developmentInputWithNoLoginClient.isResultActive(this.$routeParams.uniqueId).then((results) => {
        if (results) {
          return true;
        } else {
          this.displayMsg = `Changes have been made to this search by your client, you will now be taken back to your user dashboard`;
          this.showMsgToAdminOrBroker = true;
        }
      });
    }
    return true;
  }

  toggleLenderContactDetails(item: LenderResultSummaryDTO) {
    if (item.showLenderUserDetails == false) {
      this.summarySearchResults.forEach((offer) => (offer.showLenderUserDetails = false));
    }
    item.showLenderUserDetails = !item.showLenderUserDetails;
  }

  openSendResultsToBorrowerModal() {
    if (this.loanCriteria.showLenderNamesToBorrower == null) {
      this.organisationService.getOrganisation().then((org) => {
        this.loanCriteria.showLenderNamesToBorrower = org.showLenderNames;
      });
    }

    this.existingborrower = null;
    this.clientFirstName = this.loanCriteria.introduceeFirstName;
    this.clientSurname = this.loanCriteria.introduceeSurname;
    this.clientEmail = this.loanCriteria.introduceeEmail;
    this.clientPhoneNumber = this.loanCriteria.introduceePhone;
    this.newSearch = true;
    this.sharedSearch = true;
  }

  saveResultsForShareSearchToClient() {
    if (!this.isSaveAsClicked) {
      this.isSaveClientSearch = true;
      this.register(false, this.productResultList);
    } else {
      this.saveSaveAsSearch();
    }
  }

  getLenderNames(): string {
    if (this.filterLenderNames.length === 1) {
      return "lender " + this.filterLenderNames[0];
    } else {
      return "lenders " + this.filterLenderNames.join(", ");
    }
  }

  isLendersFiltered(): boolean {
    //If the search is empty return true
    if (!this.summarySearchResults && this.caseLenders) return true;

    if (!this.caseLenders) return false;

    //For all products that have been submitted for DIP and active, check if in the search
    return !this.caseLenders.every((lender) => {
      if (
        lender.caseLenderState !== CaseLenderStateEnum.Withdrawn &&
        lender.caseLenderState !== CaseLenderStateEnum.Rejected
      ) {
        const match = this.summarySearchResults.some(
          (summarySearchResult) => lender.productId === summarySearchResult.productID,
        );
        if (!match) {
          if (this.filterLenderNames.indexOf(lender.lenderName) === -1) {
            this.filterLenderNames.push(lender.lenderName);
          }
        }
        return match;
      }
      return true;
    });
  }

  getTotalShortlistedLenders() {
    if (this.caseLenders) {
      this.caseLendersNotInResults = this.caseLenders.filter(
        (cl) => !this.comparisonList.some((compare) => compare.seniorProductID == cl.productId),
      );

      return this.comparisonList.length + (this.caseLendersNotInResults ? this.caseLendersNotInResults.length : 0);
    } else {
      return this.comparisonList.length;
    }
  }

  reloadPage() {
    window.location.reload();
  }

  sendMessageToBroker(message) {
    this.loadingData = true;
    this.borrowerMessage = null;
    var newLeadFirstName = null,
      newLeadLastName = null,
      newLeadEmail = null;

    if (this.$location.path().startsWith("/referredSearch")) {
      newLeadFirstName = this.newUser.firstName;
      newLeadLastName = this.newUser.lastName;
      newLeadEmail = this.newUser.email;
    } else if (this.enterpriseClientId) {
      newLeadFirstName = this.loanCriteria.introduceeFirstName;
      newLeadLastName = this.loanCriteria.introduceeSurname;
      newLeadEmail = this.loanCriteria.introduceeEmail;
    } else {
      newLeadFirstName = this.newLeadFirstName;
      newLeadLastName = this.newLeadLastName;
      newLeadEmail = this.newLeadEmail;
    }

    this.organisationClient
      .sendBorrowerMessageToSearchBroker(
        0,
        message,
        newLeadFirstName,
        newLeadLastName,
        newLeadEmail,
        ProductTypeEnum.Development,
        "RESULTSSCREEN",
        this.loanCriteria.uniqueRef,
      )
      .then((results) => {
        if (results) {
          this.displayMsg = `Message has been sent successfully.`;
          this.showMessageToborrower = true;
        } else {
          this.displayMsg = `There is problem sending a message, Please try later.`;
          this.showMessageToborrower = true;
        }
      })
      .finally(() => {
        this.loadingData = false;
      });
  }

  closeContactBrokerModal() {
    this.showContactBrokerModal = false;
    this.showMessageToborrower = false;
    this.displayMsg = null;
  }

  logPdfDownload(eventName) {
    this.eventLogClient.logEvent(
      eventName,
      EventLogEnum.Export,
      ProductTypeEnum.Development,
      this.$routeParams.uniqueId ? 0 : this.loanCriteria.id,
      this.$routeParams.uniqueId ? this.$routeParams.uniqueId : "",
    );
  }

  calculateMonthsSinceOrigPurchase() {
    let date1 = new Date(this.loanCriteria.cI_Dev_DateOfOrigPurch);
    let date2 = new Date();
    let months;
    months = (date2.getFullYear() - date1.getFullYear()) * 12;
    months -= date1.getMonth();
    months += date2.getMonth();
    return months;
  }

  saveEnterpriseClientAndRenameDeal() {
    this.loadingData = true;

    this.odataHelper
      .getOne(this.applicationUserCrudClient, {
        filter: {
          email: {
            eq: this.user.email,
          },
        },
        select: { id: true },
      })
      .then((response) => {
        if (!response) {
          const userFullName = this.user.fullName;
          const spaceIndex = userFullName.indexOf(" ");

          let firstName = "";
          let lastName = "";

          // if not space has been added to the name then put the whole name in the first name field
          if (spaceIndex == -1) {
            firstName = userFullName;
          } else {
            firstName = userFullName.substring(0, userFullName.indexOf(" "));
            lastName = userFullName.substring(userFullName.indexOf(" ") + 1);
          }

          this.loanCriteria.introduceeFirstName = firstName;
          this.loanCriteria.introduceeSurname = lastName;
          this.loanCriteria.introduceeEmail = this.user.email;
          this.loanCriteria.introduceePhone = this.user.phoneNumber;

          var currentDate = new Date();
          this.loanCriteria.searchName = this.projectName;

          var result = {} as DevelopmentInputWithNoLogin;
          (<any>Object).assign(result, this.loanCriteria);
          this.developmentInputWithNoLoginClient
            .saveChangesToReferredSearch(this.loanCriteria.uniqueRef, result, true)
            .then((response) => {
              this.showEnterpriseRegistrationModal = false;
              document.getElementById("body").style.overflow = "auto";
              if (window.self == window.top) {
                sessionStorage.setItem("userDetails", JSON.stringify(this.user));
              } else {
                this.organisationService.sendDataToParent("userDetails", JSON.stringify(this.user));
              }

              const hubspotRequest: HubspotContactRequest = {
                user: this.user,
                page: "ENTERPRISE-CONTACT-REGISTERED",
                login: false,
                orgCode: this.brokerageOrg?.organisationCode,
                role: UserRoleEnum.Client,
                organisationLinkId:
                  this.loanCriteria && this.loanCriteria.organisationLinkId != null
                    ? this.loanCriteria.organisationLinkId
                    : 0,
                productType: ProductTypeEnum.Development,
                dealId: 0,
                developmentInputWithNoLoginUniqueRef: this.loanCriteria.uniqueRef,
                clientId: this.clientId ?? 0,
              };

              this.userClient.sendEventToHubspot(hubspotRequest);

              this.populateNewLeadInfo("borrower", JSON.stringify(this.user));
            })
            .finally(() => {
              this.loadingData = false;
            });
        } else {
          this.emailExistsError = true;
          this.loadingData = false;
        }
      });
  }

  addClientAndRenameDeal() {
    this.loadingData = true;
    var result = {} as DevelopmentInputWithNoLogin;
    (<any>Object).assign(result, this.loanCriteria);
    this.developmentInputWithNoLoginClient
      .addClientToSearch(this.loanCriteria.uniqueRef, Number(this.enterpriseClientId), result)
      .then((response) => {
        if (response) {
          this.loanCriteria.introduceeFirstName = response.introduceeFirstName;
          this.loanCriteria.introduceeSurname = response.introduceeSurname;
          this.loanCriteria.introduceeEmail = response.introduceeEmail;
          this.loanCriteria.introduceePhone = response.introduceePhone;
          this.loanCriteria.searchName = response.searchName;
        }
      })
      .finally(() => {
        this.loadingData = false;
      });
  }

  gotoSignInPage() {
    this.$location.path("/login");
  }

  goToLink(url) {
    var baseUrl = window.location.href.split("#!")[0] + "#!";
    var newUrl = baseUrl + url;
    window.open(newUrl, "_blank");
  }

  toggleShowLenderNamesBrokerOverride() {
    // this.loanCriteria.showLenderInfoBrokerOverride = !this.loanCriteria.showLenderInfoBrokerOverride;
    this.comparisonList = [];
    this.updateResults(undefined, true);
  }

  showContactBrokerAndExportButton() {
    if (
      this.brokerageOrg != null &&
      this.loanCriteria != null &&
      this.loanCriteria.introduceeEmail != null &&
      this.loanCriteria.introduceeEmail.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  //This is used in shortlisting pdf
  prepareDataForShortlistPdf() {
    this.loanCriteria.comparisonList = this.comparisonList;
  }

  getRegionByPostcode() {
    if (this.loanCriteria.postcodeSearchString && this.loanCriteria.postcodeSearchString.replace(" ", "").length >= 2) {
      if (this.$DevelopmentInputService.isValidPostcodeString(this.loanCriteria.postcodeSearchString)) {
        this.dataLoading = true;
        this.developmentInputClient
          .getRegionByPostcode(this.loanCriteria.postcodeSearchString)
          .then((response) => {
            if (response.location != null) {
              this.loanCriteria.cI_Dev_Locations = response.location;
              this.showPostcodeErrorMessage = false;
              this.updateSearchViaSlider();
            } else {
              this.postcodeErrorMsg = response.postCodeErrorMessage;
              this.showPostcodeErrorMessage = true;
            }
          })
          .finally(() => {
            this.dataLoading = false;
          });
      } else {
        this.postcodeErrorMsg = "At least one letter and one number must be entered e.g. SW1.";
        this.showPostcodeErrorMessage = true;
      }
    }
  }

  isSelectedResult(offer: LenderResultSummaryDTO, index: number) {
    return this.comparisonContains(offer) && !offer.isCaseLender;
  }

  isResultAvailableToSelect(offer: LenderResultSummaryDTO) {
    return offer.isCaseLender;
  }

  getOrganisationAndBrokerDetails() {
    if (!this.isLoggedInUser && !this.isAdmin && !this.isBroker) {
      this.loadingData = true;
      this.organisationClient
        .getOrganisationAndBrokerByUniqueRef(this.loanCriteria.uniqueRef)
        .then((response) => {
          if (response && response.organisation != null) {
            this.brokerageOrg = response.organisation;

            if (response.organisation.isBrickflow) {
              this.moveContactBrokerBtnInMiddle = true;
            } else {
              if (response.broker != null) {
                this.brokerDetail = `${response.broker.fullName} (${response.broker.email})`;
              }

              if (this.brokerageOrg.isWhiteLabelled) {
                this.orgName = this.brokerageOrg.name.replace(/ /g, "_");
              }
            }
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    }
  }

  sortByField(field) {
    this.loanCriteria.sortBy = field;
    this.sortSummaryResults();
    this.saveSearch(false, this.productResultList, true);
    this.showSortBy = !this.showSortBy;
  }

  sortSummaryResults() {
    switch (this.loanCriteria.sortBy) {
      case SortByEnum.ROCE:
        this.summarySearchResults.sort((a, b) => b.roce - a.roce || a.trueMonthlyCost - b.trueMonthlyCost);
        break;
      case SortByEnum.ProfitOnCost:
        this.summarySearchResults.sort(
          (a, b) => b.profitPercOfTotalCost - a.profitPercOfTotalCost || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;
      case SortByEnum.TrueMonthlyCost:
        this.summarySearchResults.sort((a, b) => a.trueMonthlyCost - b.trueMonthlyCost);
        break;
      case SortByEnum.NetLoanSize:
        this.summarySearchResults.sort((a, b) => b.netLoan - a.netLoan || a.trueMonthlyCost - b.trueMonthlyCost);
        break;
      case SortByEnum.LenderName:
        this.summarySearchResults.sort(
          (a, b) => a.loanLabel.localeCompare(b.loanLabel) || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;
      case SortByEnum.InterestRate:
        this.summarySearchResults.sort(
          (a, b) => a.annualInterest - b.annualInterest || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;
      case SortByEnum.ArrangementFee:
        this.summarySearchResults.sort(
          (a, b) => a.arrangementFee - b.arrangementFee || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;
      case SortByEnum.DepositEquity:
        this.summarySearchResults.sort((a, b) => a.deposit - b.deposit || a.trueMonthlyCost - b.trueMonthlyCost);
        break;
      case SortByEnum.LTGDV:
        this.lenderResultClient
          .sortProductsByLTGDV(this.summarySearchResults)
          .then((sortedResults) => {
            this.summarySearchResults = sortedResults;
          })
          .catch((error) => {
            console.error("Error sorting by LTGDV:", error);
          });
        break;
      default:
        this.summarySearchResults.sort((a, b) => {
          if (a.netLoan < b.netLoan) return 1;
          if (a.netLoan > b.netLoan) return -1;

          if (a.trueMonthlyCost > b.trueMonthlyCost) return 1;
          if (a.trueMonthlyCost < b.trueMonthlyCost) return -1;

          return 0;
        });
        this.loanCriteria.sortBy = SortByEnum.NetLoanSize;
    }

    for (var i = 0; i < this.summarySearchResults.length; i++) {
      this.summarySearchResults[i].selectedRowNumber = i + 1;
    }
  }

  postLoanCriteriaRetrieveProcessing(loanCriteria) {
    this.loanCriteria = loanCriteria;
    this.tempLoanRequired = this.loanCriteria.cI_Dev_LoanReq;
    if (this.loanCriteria.cI_Dev_LoanReq > 0) {
      this.isMaximumLoanRequired = false;
    }
    this.loanCriteria.saveQueryAndResults = true;
    this.isDIPClicked = this.loanCriteria.isFullCase;

    this.updateResults(false);
  }

  saveSaveAsSearch(attachClient = false) {
    this.loadingData = true;

    let newSearchName = this.isBroker || this.isAdmin ? this.loanCriteria.searchName : this.saveAsSearchName;

    let shareDealDto = {
      dealId: this.searchid,
      dealName: newSearchName,
      showLenderNamesAndLogos: this.loanCriteria?.showLenderNamesToBorrower ?? false,
      emailLinkToClient: this.emailClient,
      accessLevel: CaseAccessLevelEnum.FullAccess,
      isApplicant: true,
      isPrimary: true,
    } as ShareDealDTO;

    shareDealDto.clientDto = {
      firstName: this.clientFirstName,
      lastName: this.clientSurname,
      email: this.clientEmail,
      phoneNumber: this.clientPhoneNumber,
      clientUserId: this.clientId,
    } as Client;

    this.caseClient
      .saveSaveAsSearch(this.loanCriteria.id, attachClient, shareDealDto)
      .then((result) => {
        this.displayMsg = `${newSearchName} search has been saved to your dashboard.`;
      })
      .catch((error) => {
        this.displayMsg = "Sorry, something went wrong. Please try again.";
      })
      .finally(() => {
        this.cancelNewSearch();
        this.loadingData = false;
        this.isSaveAsClicked = false;
        this.saveAsSearchName = "";
        this.showSaveResults = null;
        this.showMsg = true;
      });
  }

  returnShortlistedDealLenderStatusText(item: LenderResultSummaryDTO) {
    if (
      item.isCaseLender &&
      this.currentCase.caseStatus != CaseStatusEnum.Search &&
      this.currentCase.caseStatus != CaseStatusEnum.NewCase &&
      this.currentCase.caseStatus != CaseStatusEnum.ReadyToSubmit
    ) {
      switch (item.caseLenderStatus) {
        case CaseLenderStateEnum.Shortlisted:
          return "Shortlisted";
        case CaseLenderStateEnum.Received:
          return "Awaiting DIP";
        case CaseLenderStateEnum.Offered:
          return "DIP Received";
        case CaseLenderStateEnum.Rejected:
          return "Lender Rejected";
        case CaseLenderStateEnum.Withdrawn:
          return "Lender Withdrawn";
        case CaseLenderStateEnum.Applied:
          return "DIP Accepted";
        case CaseLenderStateEnum.Cancelled:
          return "Cancelled";
        default:
          break;
      }
    }
  }

  onFilterClick() {
    //This is added to show only applied filters on pill
    if (this.showFilters && !this.isLoggedInUser) {
      this.loanCriteria = { ...this.tempLoanCriteria };
    }
    this.showFilters = !this.showFilters;
  }

  onSortbyClick() {
    this.showSortBy = !this.showSortBy;
  }

  getSelectedSortByOptionText() {
    if (this.loanCriteria) {
      switch (this.loanCriteria.sortBy) {
        case SortByEnum.TrueMonthlyCost:
          return "True Monthly Cost";
        case SortByEnum.NetLoanSize:
          return "Net Loan Size";
        case SortByEnum.LenderCosts:
          return "Lender Costs (Est.)";
        case SortByEnum.LenderName:
          return "Lender Name (A-Z)";
        case SortByEnum.InterestRate:
          return "Interest Rate";
        case SortByEnum.ArrangementFee:
          return "Arrangement Fee";
        case SortByEnum.DepositEquity:
          return "Est. Deposit/Equity";
        case SortByEnum.ROCE:
          return "ROCE";
        case SortByEnum.LTGDV:
          return "LTGDV";
        case SortByEnum.ProfitOnCost:
          return "Profit On Cost";
        default:
          return "";
      }
    } else {
      return "";
    }
  }

  getSummaryComparisonList() {
    this.summaryComparisonList = [];
    for (var i = 0; i < this.comparisonList.length; i++) {
      let resultIndex = this.summarySearchResults.findIndex(
        (item) => item.productID == this.comparisonList[i].seniorProductID,
      );

      if (resultIndex > -1) {
        this.summaryComparisonList.push(this.summarySearchResults[resultIndex]);
      }
    }

    return this.summaryComparisonList;
  }

  isProceedButtonDisabled(): boolean {
    if (
      !this.comparisonList ||
      this.comparisonList.length < 1 ||
      this.comparisonList.length > this.noOfShortlistAllowed ||
      this.isProceedClicked == true
    ) {
      return true;
    }

    return false;
  }

  onSaveClick() {
    if (this.loanCriteria.introduceeEmail) {
      this.isSaveorSaveAsClicked = true;
      this.register(false, this.productResultList);
    } else {
      this.showShareSearchModal();
    }
  }
}
